/**
 * @license
 * @qwik.dev/core 2.0.0-beta.34-dev+58bbaf9
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as oe, isBrowser as le } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as se } from "@qwik.dev/core/preloader";

const ue = !1;

const ce = globalThis;

const fe = ce.qDev !== !1;

const ae = ce.qDynamicPlatform !== !1;

const he = ce.qTest === !0;

const de = ce.qRuntimeQrl === !0;

const pe = t => {
    fe && Object.seal(t);
};

const $e = fe ? "background: #564CE0; color: white; padding: 2px 3px; border-radius: 2px; font-size: 0.8em;" : "";

const me = /*#__PURE__*/ new Set;

const ye = (t, ...n) => {
    if (fe) {
        const e = "warn" + t;
        if (!me.has(e)) {
            me.add(e);
            we(t, ...n);
        }
    }
};

const we = (t, ...n) => {
    fe && console.warn("%cQWIK WARN", $e, t, ...n);
};

const be = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    !he && console.error("%cQWIK ERROR", $e, s.message, ...e, s.stack);
    t && !he && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const ve = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const ge = (t, n, e, s, o = !1) => {
    const r = ve(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const _e = (t, n, e) => {
    const s = ve(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Se = (t, n, e) => ve(t, n, e) >= 0;

const ke = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const Ee = t => typeof t === "object" && t !== null;

const xe = t => Array.isArray(t);

const Te = t => typeof t === "string";

const qe = t => typeof t === "function";

const Re = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = be(fe, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const Pe = "<sync>";

const Ae = t => typeof t === "function" && typeof t.getSymbol === "function";

const sh = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const Me = "q:type";

const Ne = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const Ie = 124;

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const Ce = "q:renderFn";

const je = "q:targetEl";

const Oe = "⚡️";

const Fe = "q:slot";

const Le = "q:s";

const De = "q:style";

const Ve = "style[q\\:style]";

const We = Ve + ",style[q\\:sstyle]";

const Ue = "q:sstyle";

const ze = "q:ctx";

const Xe = "q:brefs";

const Qe = (t, n) => t["qFuncs_" + n] || [];

const Be = "q:base";

const He = "q:container-island";

const Je = "/" + He;

const Ye = "q:ignore";

const Ge = "/" + Ye;

const Ke = "q:container";

const Ze = "/" + Ke;

const tr = "q:template";

const nr = "http://www.w3.org/1999/xhtml";

const er = "http://www.w3.org/2000/svg";

const rr = "http://www.w3.org/1998/Math/MathML";

const ir = "qRender";

const or = "q:key";

const lr = "q:props";

const ur = "q:seq";

const cr = "q:seqIdx";

const fr = "q:p";

const ar = "q:ps";

const dr = ":on";

const pr = ":onIdx";

const $r = ":onFlags";

const mr = "q:cursorBoundary";

const yr = ":nearestCursorBoundary";

const wr = ":";

const br = "dangerouslySetInnerHTML";

const vr = "__scopedStyleIdPrefix__";

const gr = 100;

const _r = t => !!t && typeof t == "object" && typeof t.then === "function";

const Sr = (t, n, e) => {
    try {
        const s = t();
        return _r(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const kr = (t, n) => _r(t) ? t.then(n) : n(t);

const Er = t => {
    throw t;
};

function n(t, n = Er) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!_r(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = gr;
    const r = async e => {
        for (;_r(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!_r(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const xr = t => Oe + t;

const Tr = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + xr(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const qr = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + Rr(t.slice(s, -1));
        }
    }
    return null;
}

const Rr = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = Pr(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const Pr = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const Ar = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const Mr = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const Nr = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const Ir = t => {
    if (!t) {
        return "";
    }
    if (Te(t)) {
        return t.trim();
    }
    const n = [];
    if (xe(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = Ir(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const Cr = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

function r(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = Ir(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = (t => {
            if (t == null) {
                return "";
            }
            if (typeof t == "object") {
                if (xe(t)) {
                    throw Re(0, [ t, "style" ]);
                }
                {
                    const n = [];
                    for (const e in t) {
                        if (Object.prototype.hasOwnProperty.call(t, e)) {
                            const s = t[e];
                            s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(Cr(e) + ":" + jr(e, s)));
                        }
                    }
                    return n.join(";");
                }
            }
            return t + "";
        })(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const jr = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => Mr.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const Or = () => ({
    isServer: oe,
    importSymbol(t, n, e) {
        if (oe) {
            const t = sh(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw Re(6, [ e ]);
        }
        if (!n) {
            throw Re(14, [ e ]);
        }
        if (!t) {
            throw Re(13, [ n, e ]);
        }
        const s = "" + Fr(t.ownerDocument, t, n);
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const Fr = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(Be) ?? s, s);
    return new URL(e, o);
};

let Lr = /*#__PURE__ */ Or();

const Dr = t => Lr = t;

const Vr = () => Lr;

const Wr = () => {
    if (ae) {
        return Lr.isServer;
    }
    return !1;
};

const Ur = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        e.port1.onmessage = () => t();
        n = () => e.port2.postMessage(null);
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const zr = import.meta.env.TEST ? !Wr() : !oe;

const Xr = zr ? document : void 0;

const Qr = zr && Xr.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

performance.now();

const Br = /\.[mc]?js$/;

const Hr = 1e3 / 60;

import.meta.env.TEST && Wr();

const Jr = t => {
    let n = Yr.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            Dt: t,
            It: Br.test(t) ? 0 : 3,
            Vt: n,
            Wt: 1,
            Ut: performance.now(),
            zt: 0,
            Xt: 0
        }))(t, e);
        Yr.set(t, n);
    }
    return n;
};

const Yr = new Map;

let Gr = 0;

const Kr = [];

const Zr = Ur(function oh() {
    ni = !1;
    if (!Kr.length) {
        return;
    }
    const t = performance.now() + Hr;
    let n = !1;
    for (;Kr.length; ) {
        const e = Kr[0];
        const s = e.Wt;
        const o = 1 - s;
        if (!(o >= .99 || Gr < 25)) {
            break;
        }
        Kr.shift();
        li(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && Kr.length && !ni) {
        ni = !0;
        Zr();
    }
});

const ti = Ur(i);

let ni = !1;

let ei = !1;

let ri = !1;

const ii = import.meta.env.TEST ? !Wr() : le;

const si = [];

const oi = () => {
    const t = si[si.length - 1];
    const n = t.Qt;
    if (t.Vt) {
        const e = t.Bt;
        if (e >= t.Vt.length) {
            si.pop();
            return !1;
        }
        const s = t.Vt[e];
        t.Bt = e + 1;
        const o = Jr(s.Dt);
        if (o.Wt === 0) {
            return !0;
        }
        const r = 1 - n.Wt;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s.Ht);
        } else {
            const t = 1 - s.Ht * r;
            const n = s.Jt;
            const e = t / n;
            i = Math.max(.02, o.Wt * e);
            s.Jt = e;
        }
        si.push({
            Qt: o,
            Wt: i,
            Yt: t.Yt
        });
        return !0;
    }
    if (t.Yt?.has(n)) {
        si.pop();
        return !1;
    }
    const e = n.Wt;
    n.Wt = t.Wt;
    if (e - n.Wt < .01) {
        si.pop();
        return !1;
    }
    if (n.Vt?.length) {
        const e = t.Yt || new Set;
        e.add(n);
        t.Yt = e;
        t.Vt = n.Vt;
        t.Bt = 0;
        return !1;
    }
    si.pop();
    return !1;
};

function i() {
    if (ri || !si.length) {
        return;
    }
    ei = !1;
    ri = !0;
    const t = ii ? performance.now() + Hr : 0;
    let n = !1;
    for (;si.length; ) {
        n = !0;
        const e = oi();
        if (ii && e && performance.now() >= t) {
            if (!ei) {
                ei = !0;
                ti();
            }
            break;
        }
    }
    ri = !1;
    n && ii && Zr();
}

const li = t => {
    if (t.It >= 2) {
        return;
    }
    Gr++;
    const n = performance.now();
    t.zt = n - t.Ut;
    t.It = 2;
    const e = Xr.createElement("link");
    e.href = "" + new URL("undefined" + t.Dt, Xr.baseURI);
    e.rel = Qr;
    e.as = "script";
    e.onload = e.onerror = () => {
        Gr--;
        const s = performance.now();
        t.Xt = s - n;
        t.It = 4;
        e.remove();
        Zr();
    };
    Xr.head.appendChild(e);
};

const ui = (t, n) => {
    const e = Jr(t);
    e && ((t, n) => {
        si.unshift({
            Qt: t,
            Wt: n,
            Yt: void 0
        });
    })(e, n);
};

(import.meta.env.TEST ? !Wr() : le) && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    ui(e, 0);
                }
            } else {
                ui(t, 0);
            }
            ii ? ti() : i();
        })(t);
    }
});

const ci = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const fi = ",";

const ai = "2.0.0-beta.34-dev+58bbaf9";

const hi = t => t.nodeType === 1;

const di = Symbol();

class pi {
    [di]=void 0;
}

const $i = t => t === "foreignObject";

const mi = t => t === "svg" || $i(t);

const yi = t => t === "math";

function s(t, n, e, o = !1) {
    const r = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== wr && r.setAttribute(e.name, e.value);
    }
    if (o) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const i = t.childNodes[n];
            const c = i.nodeType;
            c === 3 ? r.appendChild(i.cloneNode()) : c === 1 && r.appendChild(s(i, i.localName, e, o));
        }
    }
    return r;
}

const wi = {
    elementNamespace: nr,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!$l(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && $i($l(t));
    let o = nr;
    let r = 0;
    const i = typeof n === "string" || Oo(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return mi(t);
        }
        if (Oo(t)) {
            return mi($l(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = er;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return yi(t);
        }
        if (Oo(t)) {
            return yi($l(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = rr;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? er : e ? rr : nr;
        r = t.flags & 1536;
    }
    wi.elementNamespace = o;
    wi.elementNamespaceFlag = r;
    return wi;
}

class bi {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [di]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class vi extends bi {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class gi extends vi {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class _i extends bi {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const Si = [];

const ki = [];

function l(t, n) {
    const e = d(n).priority;
    let s = Si.length;
    for (let t = 0; t < Si.length; t++) {
        const n = d(Si[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Si.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < Si.length; t++) {
        const n = Si[t];
        let e = !1;
        for (let t = 0; t < ki.length; t++) {
            const s = ki[t];
            if (Ol(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    ki.push(t);
    a(t, n, !0);
    n.o++;
}

function f(t, n) {
    const e = ki.indexOf(t);
    if (e !== -1) {
        const t = ki.length - 1;
        e !== t && (ki[e] = ki[t]);
        ki.pop();
        n.o--;
    }
    l(n, t);
}

function a(t, n, e) {
    e || (t.flags &= -257);
    const s = Si.indexOf(t);
    if (s !== -1) {
        Si.splice(s, 1);
        n.o--;
    }
}

const Ei = new WeakMap;

const xi = ":nodeProps";

const Ti = ":nodeDiff";

const qi = ":errorData";

const Ri = ":signal";

function h(t, n, e) {
    n.position = e;
    e && en(e) && function s(t, n, e) {
        a(e, t);
        const s = d(e);
        if (s === n) {
            return;
        }
        const o = s.afterFlushTasks;
        if (o && o.length > 0) {
            const t = n.afterFlushTasks;
            t ? t.push(...o) : n.afterFlushTasks = o;
        }
        const r = s.extraPromises;
        if (r && r.length > 0) {
            const t = n.extraPromises;
            t ? t.push(...r) : n.extraPromises = r;
        }
        const i = s.journal;
        if (i && i.length > 0) {
            const t = n.journal;
            t ? t.push(...i) : n.journal = i;
        }
        const c = s.boundaries;
        if (__EXPERIMENTAL__.suspense && c && c.length > 0) {
            const t = n.boundaries ||= [];
            for (let n = 0; n < c.length; n++) {
                const e = c[n];
                t.includes(e) || t.push(e);
            }
        }
    }(t, n, e);
}

function d(t) {
    return Ei.get(t) ?? null;
}

const Pi = Symbol();

class Ai {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const Mi = Symbol();

const Ni = Symbol();

const Ii = Symbol();

function p(t, n, e) {
    t[di] || (oe && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(Xe, new Map) : t[di] = new Map);
    const o = t[di];
    let r = o.get(n);
    if (!r) {
        r = new Ai(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const Ci = (t, n) => (e, s) => {
    const o = re();
    o.Ot = p(t, ":");
    o.$ = n || void 0;
    return te(o, () => {
        if (qe(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (Gl(e)) {
            return e.value;
        }
        if (Ee(e) && au(e)) {
            Sn(lu(e), Ii, ou(e), o.Ot);
            return e;
        }
        throw Re(2);
    });
};

class ji {
    Gt;
    ut=void 0;
    $=null;
    Kt=null;
    constructor(t, n) {
        this.$ = t || jc()?.$ || null;
        this.Gt = n;
    }
    trigger() {
        nu(this.$, this, this.ut);
    }
    force() {
        nu(this.$, this, this.ut);
    }
    get untrackedValue() {
        return this.Gt;
    }
    set untrackedValue(t) {
        this.Gt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = jc();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.Ot;
        if (e) {
            Kl(this.ut ||= new Set, e);
            Zl(e, this);
            (import.meta.env.TEST ? !Mc(this.$) : oe) && tu(e, this.$);
        }
        return t;
    }
    set value(t) {
        if (t !== this.Gt) {
            this.Gt = t;
            nu(this.$, this, this.ut);
        }
    }
    valueOf() {
        if (fe) {
            throw Re(28);
        }
    }
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Gt
        };
    }
}

class Oi extends ji {
    Zt;
    h;
    [di]=void 0;
    constructor(t, n, e = 17) {
        super(t || jc()?.$, Pi);
        this.Zt = n;
        this.h = e;
    }
    invalidate() {
        this.h |= 1;
        const t = re();
        t.$ = this.$ || void 0;
        const e = n(ne.bind(this, t, this.p));
        e && e.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get untrackedValue() {
        this.p();
        return this.Gt;
    }
    set untrackedValue(t) {
        this.Gt = t;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = this.Zt;
        Yl(t);
        const n = jc();
        const e = n?.Ot;
        if (n) {
            const t = p(this, ".");
            mn(this.$, t);
            n.Ot = t;
        }
        try {
            const e = t.getFn(n)();
            if (_r(e)) {
                throw Re(29, [ t.dev ? t.dev.file : "", t.st ]);
            }
            this.h &= -2;
            super.value = e;
        } finally {
            n && (n.Ot = e);
        }
    }
}

class Fi {
    tn;
    nn=null;
    en=!1;
    rn=!0;
    constructor(t, n, e) {
        this.tn = t;
        if (n !== void 0) {
            this.info = n;
            this.sn = e;
        }
    }
    get track() {
        return this.ln ||= Ci(this.tn, this.tn.$);
    }
    get abortSignal() {
        return (this.un ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.tn.Gt;
        if (t !== Pi) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.cn ||= []).push(t);
    }
}

class Li extends Oi {
    fn=!1;
    an=void 0;
    hn=null;
    [di]=void 0;
    constructor(t, n, e = 17, s) {
        super(t, n, e);
        if (!s) {
            return;
        }
        const o = s.initial;
        if (o !== void 0) {
            const t = typeof o === "function" ? o() : o;
            this.Gt = t;
        }
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.dn = r;
            this.pn = [];
        }
        const i = s.timeout;
        i && (this.$n = i);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 64);
        s.allowStale === !1 && (this.h |= 128);
        const c = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        c && (this.expires = c);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    get untrackedValue() {
        this.p();
        if (this.hn?.nn) {
            if (this.Gt === Pi || (import.meta.env.TEST ? Wr() : oe)) {
                throw this.hn?.nn;
            }
            return this.Gt;
        }
        if (this.an) {
            throw this.an;
        }
        if ((import.meta.env.TEST ? Wr() : oe) && this.h & 64 && this.Gt === Pi) {
            throw Re(35);
        }
        return this.Gt;
    }
    set untrackedValue(t) {
        this.Gt = t;
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedLoading = !1;
        this.untrackedError = void 0;
        this.mn = void 0;
        if (this.pn) {
            for (let t = 0; t < this.pn.length; t++) {
                this.pn[t].rn = !1;
            }
        } else {
            this.hn && (this.hn.rn = !1);
        }
        this.yn();
        super.value = t;
        this.wn();
    }
    get loading() {
        const t = this.untrackedLoading;
        const n = jc();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Ot;
            if (t) {
                Kl(this.dt ||= new Set, t);
                Zl(t, this);
                tu(t, this.$);
            }
        }
        return t;
    }
    set untrackedLoading(t) {
        if (t !== this.fn) {
            this.fn = t;
            nu(this.$, this, this.dt);
        }
    }
    get untrackedLoading() {
        this.p();
        if ((import.meta.env.TEST ? Wr() : oe) && this.hn?.nn) {
            throw this.hn?.nn;
        }
        return this.fn;
    }
    get error() {
        const t = this.untrackedError;
        const n = jc();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Ot;
            if (t) {
                Kl(this.$t ||= new Set, t);
                Zl(t, this);
                tu(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.an) {
            this.an = t;
            nu(this.$, this, this.$t);
        }
    }
    get untrackedError() {
        return this.an;
    }
    get expires() {
        return this.xt || 0;
    }
    set expires(t) {
        this.yn();
        this.xt = t;
        this.xt && this.bn() && this.wn();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.xt && this.bn()) {
            this.yn();
            this.wn();
        }
    }
    get interval() {
        const t = this.xt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    async invalidate(t) {
        if (arguments.length > 0) {
            this.mn = t;
            this.sn = this.sn === void 0 ? 1 : this.sn + 1;
        }
        this.vn(!0, this.h & 128);
    }
    vn(t, n) {
        this.h |= 1;
        this.yn();
        n && (this.Gt = Pi);
        t && (this.ut?.size || this.dt?.size || this.$t?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.hn && this.gn(this.hn, t);
    }
    yt() {
        if (!(this.h & 32) || this.bn()) {
            return;
        }
        if (!(import.meta.env.TEST ? !Wr() : le)) {
            return;
        }
        setTimeout(() => {
            this.bn() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.hn?.nn; ) {
            await (this.hn?.nn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if ((import.meta.env.TEST ? Wr() : oe) && this.h & 64) {
            this.fn = !0;
            this.$?.serializationCtx.Tt.add(this);
            return;
        }
        this.yn();
        this.h &= -2;
        const t = this.hn;
        t && this.gn(t);
        const n = this.dn === 0 ? Infinity : this.dn ?? 1;
        if (this.pn ? this.pn.length >= n : t?.nn) {
            this.h |= 1;
            return;
        }
        const e = this.sn;
        const s = new Fi(this, this.mn, e);
        this.hn = s;
        this.pn && this.pn.push(s);
        s.nn = this._n(s);
    }
    async _n(t) {
        let e = this.Zt.resolved;
        if (!e) {
            this.untrackedLoading = !0;
            e = await this.Zt.resolve();
            if (t.un?.signal.aborted) {
                t.nn = null;
                return;
            }
        }
        try {
            this.$n && (this.Sn = setTimeout(() => {
                const n = Error(`timeout ${this.$n}ms`);
                this.kn(t, n);
                t.un?.abort(n);
            }, this.$n));
            const s = n(e.bind(null, t));
            let o;
            if (_r(s)) {
                this.untrackedLoading = !0;
                o = await s;
            } else {
                o = s;
            }
            t.nn = null;
            if (t.rn) {
                const n = this.pn;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].rn = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = o;
            }
        } catch (n) {
            t.nn = null;
            this.kn(t, n);
        }
        if ((() => t === this.hn)()) {
            clearTimeout(this.Sn);
            t.sn === this.sn && (this.mn = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedLoading = !1;
                this.wn();
            }
        }
    }
    kn(t, n) {
        if (t !== this.hn || !t.rn) {
            return;
        }
        t.rn = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = Pi;
    }
    async En() {
        this.yn();
        clearTimeout(this.Sn);
        const t = this.hn;
        t && this.gn(t);
        this.pn ? await Promise.all(this.pn.map(t => t.nn)) : await (t?.nn);
    }
    yn() {
        if (this.xn !== void 0) {
            clearTimeout(this.xn);
            this.xn = void 0;
        }
    }
    wn() {
        if ((import.meta.env.TEST ? Wr() : oe) || !this.xt) {
            return;
        }
        this.yn();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.xn = setTimeout(() => this.vn(t, n), this.xt);
        this.xn?.unref?.();
    }
    bn() {
        return !!(this.ut?.size || this.dt?.size || this.$t?.size);
    }
    gn(t, n) {
        if (t.en) {
            return;
        }
        t.en = !0;
        t.un?.abort(n);
        t.nn = kr(t.nn, () => this.Tn(t));
    }
    Tn(t) {
        const n = t.cn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        const s = () => {
            t.nn = null;
            n && (n.length = 0);
            const e = this.pn;
            if (e) {
                const n = e.indexOf(t);
                n !== -1 && e.splice(n, 1);
            }
            this.p();
        };
        let o;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const s = n[t]();
                    _r(s) && (o = (o ? o.then(() => s) : s).catch(e));
                } catch (t) {
                    e(t);
                }
            }
        }
        if (o) {
            return o.then(s);
        }
        s();
    }
}

const Di = Symbol();

const Vi = Symbol();

const Wi = Symbol();

const Ui = Symbol();

const zi = Symbol();

const Xi = Symbol();

const Qi = [];

const Bi = {};

Object.freeze(Qi);

Object.freeze(Bi);

function $(t) {
    return new Proxy({}, new Hi(t));
}

class Hi {
    owner;
    ut=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === Di) {
            return this.owner.constProps;
        }
        if (n === Vi) {
            return this.owner.varProps;
        }
        if (n === Wi) {
            return this.owner;
        }
        if (n === Ui) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = Gi(this.owner, n);
            n in this.owner.varProps && Ji(this, n);
        }
        return s instanceof ys && s.h & 4 ? s.value : s;
    }
    set(t, n, s) {
        if (n === Wi) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === Di) {
            this.owner.constProps = s;
        } else if (n === Vi) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === Bi ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                Yi(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && Yi(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === Di || n === Vi) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && Ji(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const Ji = (t, n) => {
    const e = jc();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.Ot;
    s && Sn(t.owner._proxy, n, t, s);
};

const Yi = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ut, n);
    e && nu(t.$, t, e);
    return !!e;
};

const Gi = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const Ki = (t, n) => Zi(t)?.[n] || ts(t)?.[n] || null;

const Zi = t => {
    if (!t) {
        return null;
    }
    return Vi in t ? "children" in t ? {
        ...t[Vi],
        children: t.children
    } : t[Vi] : t;
};

const ts = t => {
    if (!t) {
        return null;
    }
    return Di in t ? t[Di] : null;
};

const ns = t => t && Vi in t;

const es = t => (n, ...e) => t.call(null, wf(n), ...e);

class rs extends Oi {
    constructor(t, n) {
        super(t, n, 17);
    }
    qn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        Yl(this.Zt);
        const t = Dc(this.Zt.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Gt === Pi ? e : this.Gt;
        const r = Wc(() => this.qn ? s?.(o) || o : n(o), this, ".", this.$);
        this.qn = !0;
        this.h &= -2;
        const i = this.qn && r !== "undefined" || r !== this.Gt;
        if (i) {
            this.Gt = r;
            nu(this.$, this, this.ut);
        }
    }
}

const is = (t, n) => new Oi(n?.container || null, t, ru(n?.serializationStrategy || "always"));

const ss = (t, n) => new Li(n?.container || null, t, ru(n?.serializationStrategy || "always"), n);

const os = t => new rs(null, t);

const ls = t => new ji(null, t);

const us = /*#__PURE__*/ es(is);

const cs = /*#__PURE__*/ es(ss);

const fs = es(os);

const as = t => t.value;

const hs = (t, n) => t[n];

const ds = t => {
    if (t.length === 1) {
        if (Gl(t[0])) {
            return t[0].Kt ||= new ys(null, as, t, null);
        }
        if (au(t[0])) {
            return new ys(null, as, t, null);
        }
        return t[0].value;
    }
    return new ys(null, hs, t, null);
};

const ps = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!Ee(n)) {
        return n[e];
    }
    if (Gl(n)) {
        if (n instanceof ys && n.h & 4) {
            return n;
        }
        return ds(t);
    }
    if (ns(n)) {
        const s = n[Di];
        const o = n[Vi];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return $s(n, t);
        }
    } else {
        const s = lu(n);
        if (s) {
            const n = s[e];
            return $s(n, t);
        }
    }
    return n[e];
};

const $s = (t, n) => Gl(t) ? t : ds(n);

const ms = (t, n) => {
    const e = ps(t, n);
    if (e === zi) {
        return t[n];
    }
    return e;
};

class ys extends ji {
    lt;
    ot;
    kt;
    h;
    m=void 0;
    [di]=void 0;
    constructor(t, n, e, s, o = 5) {
        super(t, Pi);
        this.lt = e;
        this.ot = n;
        this.kt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this.m) {
                this.$.setHostProp(this.m, Ri, this);
                on(this.$, this.m, 16);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            nu(this.$, this, this.ut);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Gt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = Wc(() => this.ot(...this.lt), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Gt;
        if (n) {
            this.h |= 2;
            this.Gt = t;
        }
    }
    it() {
        return this.ot === as && Gl(this.lt[0]) ? this.lt[0] : this;
    }
    set value(t) {
        throw Re(31);
    }
    get value() {
        return super.value;
    }
}

class ws {
    data;
    constructor(t) {
        this.data = t;
    }
}

const bs = (t, n) => {
    if (typeof t === "string") {
        const e = Jn(n);
        sf(of(e, t));
    }
    return null;
};

function m(t, n) {
    bs(this, n);
    const e = rf[0];
    e.value = n.type === "number" ? n.valueAsNumber : n.value;
}

function y(t, n) {
    bs(this, n);
    const e = rf[0];
    e.value = n.checked;
}

function w(t, n) {
    bs(this, n);
    if (rf) {
        for (let t = 0; t < rf.length; t++) {
            const n = rf[t];
            n instanceof Li && n.h & 64 && n.p();
        }
    }
}

const vs = Object.prototype.hasOwnProperty;

class gs {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || ci(n) ? Bi : n;
        this.constProps = !e || ci(e) ? null : e;
        fe && c && (this.dev = {
            ...c,
            stack: Error().stack?.split("\n").slice(2).join("\n")
        });
        pe(this);
    }
    get props() {
        return this._proxy ||= $(this);
    }
}

const _s = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const Ss = t => {
    if (fe) {
        if (t instanceof gs) {
            return !0;
        }
        if (Ee(t) && vs.call(t, "key") && vs.call(t, "props") && vs.call(t, "type")) {
            if (ns(t)) {
                return !1;
            }
            we('Duplicate implementations of "JSXNode" found');
            return !0;
        }
        return !1;
    }
    return t instanceof gs;
};

const ks = "bind:value";

const Es = "bind:checked";

const xs = "passive:";

const Ts = "preventdefault:";

const qs = Object.prototype.hasOwnProperty;

const Rs = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(Rr(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const Ps = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return Rr(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return Rr(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return Rr(t.slice(11, -1));
    }
    return null;
};

const As = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = Ps(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const Ms = (t, n, e, s, o, r, i) => new gs(t, n, e, s, o, r, !1, i);

const Ns = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const h = [];
        const d = [];
        const p = [];
        const $ = new Map;
        const w = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                $.set(o, n++);
                if (o.startsWith(xs)) {
                    r.push(o);
                    t.add(Rr(o.slice(8)));
                } else {
                    o.startsWith(Ts) ? d.push(o) : Ps(o) !== null ? s.push(o) : o === Es ? a = e[o] : o === ks && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                w.set(s, e++);
                if (s.startsWith(xs)) {
                    h.push(s);
                    t.add(Rr(s.slice(8)));
                } else {
                    s.startsWith(Ts) ? p.push(s) : Ps(s) !== null ? o.push(s) : s === Es ? a = n[s] : s === ks && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = Rs(e, r, d, t, l);
            l = l || e !== n;
            e = As(e, s, $, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = Rs(n, h, p, t, u);
            u = u || n !== e;
            n = As(n, o, w, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && qs.call(n, Es) && delete n[Es];
                if (e && qs.call(e, Es)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Es];
                }
                n.checked = a;
                const t = ff(null, "_chk", y, null, [ a ]);
                if (e && qs.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = _s(n, "q-e:input", t) || c;
                }
                c = _s(n, "q-e:input", t) || c;
            } else if (f) {
                n && qs.call(n, ks) && delete n[ks];
                if (e && qs.call(e, ks)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[ks];
                }
                n.value = f;
                const t = ff(null, "_val", m, null, [ f ]);
                if (e && qs.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = _s(n, "q-e:input", t) || c;
                }
                c = _s(n, "q-e:input", t) || c;
            }
        }
        if (n && qs.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
            fe && ye(`jsx${i ? ` ${i.fileName}${i?.lineNumber ? ":" + i.lineNumber : ""}` : ""}: \`className\` is deprecated. Use \`class\` instead.`);
        }
        if (e && qs.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
            fe && ye(`jsx${i ? ` ${i.fileName}${i?.lineNumber ? ":" + i.lineNumber : ""}` : ""}: \`className\` is deprecated. Use \`class\` instead.`);
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new gs(t, n, e, s, o, r, c || !0, i);
};

const Is = (t, n, e, s) => Fs(t, n, s);

const Cs = (t, n, e, s, o) => Fs(t, {
    ...e,
    ...n
}, o);

const js = (t, n, e, s, o, r) => Fs(t, {
    ...e,
    ...n,
    children: s
}, r);

const Os = t => t.children;

const Fs = (t, n, e, s, o) => Ns(t, n, null, null, 0, e, o);

const Ls = Fs;

const Ds = Fs;

function b(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return Ns(t, n, null, s.children, 0, o);
}

const Vs = t => t.children;

const Ws = (t, n) => new gs(Os, null, null, t.children, 0, n);

const Us = (t, n, e, s, o) => {
    const r = ee(t.Ct, e || n, t);
    if (e) {
        r.Ot = p(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, Ce));
    if (Ae(s)) {
        o = o || t.getHostProp(n, lr) || Bi;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (kf(s)) {
        const t = s;
        i = () => ne(r, t, [ o || Bi, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => ne(r, t, [ o || Bi ]);
    }
    const l = import.meta.env.TEST ? Wr() : oe;
    const u = (e = 0) => Sr(() => {
        if (!c) {
            t.setHostProp(n, cr, null);
            t.setHostProp(n, pr, null);
        }
        e > 0 && jo(n) && $n(t, n);
        return kr(i(o), t => kr(r.Ft, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < gr) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, dr);
        if (o) {
            return function r(t, n) {
                const e = S(t);
                let s = t;
                const o = "q-e:qvisible";
                return kr(e, t => {
                    const e = !t;
                    let r = null;
                    for (const i in n) {
                        if (Object.prototype.hasOwnProperty.call(n, i)) {
                            let c = t;
                            let l = i;
                            if (e) {
                                if (i !== o && !i.startsWith("q-d:") && !i.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!r) {
                                    const [t, n] = k(s);
                                    s = n;
                                    r = t;
                                }
                                c = r;
                            }
                            if (c) {
                                c.type === "script" && i === o && (l = "q-d:qinit");
                                g(c, l, n[i]);
                            }
                        }
                    }
                    return s;
                });
            }(s, o);
        }
        return s;
    }, t => {
        if (_r(t) && e < gr) {
            return t.then(() => u(++e));
        }
        if (e >= gr) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function g(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = Ar(n);
    c && _(t, f, "capture");
    l && _(t, f, "preventdefault");
    u && _(t, f, "stoppropagation");
}

function _(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === Bi && (t.varProps = {});
    t.varProps[s] = !0;
}

function S(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (Ss(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (xe(t)) {
            n.push(...t);
        } else {
            if (_r(t)) {
                return kr(t, t => S(t));
            }
            if (Gl(t)) {
                return S(t.untrackedValue);
            }
        }
    }
    return null;
}

function k(t) {
    if (Ss(t)) {
        const n = E();
        if (t.type !== Vs && !kf(t.type)) {
            return [ n, Ms(Vs, null, null, [ t, n ], 0, null) ];
        }
        t.children == null ? t.children = n : xe(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return [ n, t ];
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        const n = E();
        return [ n, Ms(Vs, null, null, [ t, n ], 0, null) ];
    }
    if (xe(t) && t.length > 0) {
        const [n, e] = k(t[0]);
        return [ n, t ];
    }
    return [ null, t ];
}

function E() {
    return new gs("script", null, {
        hidden: ""
    }, null, 0, null);
}

const zs = t => Ms(Os, null, {
    [Le]: ""
}, t.children, 0, t.name ?? "");

const Xs = Symbol();

const Qs = () => null;

const Bs = () => null;

const Hs = t => t.children;

const Js = (t, n) => Fs(Ws, {
    children: Fs(Ys, t)
}, n);

const Ys = () => null;

let Gs = null;

let Ks = null;

function x(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    Ks || (Ks = t.setAttributeNS);
                    Ks.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            Gs || (Gs = t.setAttribute);
            Gs.call(t, n, e);
        })(t, n, e);
    }
}

function T(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const Zs = (t, n = [], e = {}) => {
    let s = null;
    const o = t[Di];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[Vi];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return $(new gs(null, r, s, null, 0, null));
};

class to {
    target;
    constructor(t) {
        this.target = t;
    }
}

class no {
    target;
    constructor(t) {
        this.target = t;
    }
}

class eo {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class ro {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class io {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const so = t => new to(t);

const oo = t => new no(t);

const lo = (t, n) => new eo(t, n);

const uo = (t, n, e) => new ro(t, n, e);

const co = (t, n, e, s = null, o = !1) => new io(t, n, e, s, o);

const fo = () => {
    const t = Fc();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, ur);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, ur, s);
    }
    let o = t.$.getHostProp(e, cr);
    o === null && (o = 0);
    t.$.setHostProp(e, cr, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => {
            fe && mc(t);
            return s[o] = t;
        },
        i: o,
        iCtx: t
    };
};

const ao = t => {
    const n = qe(t) && !kf(t) ? te(void 0, t) : t;
    return ls(n);
};

const ho = t => po(ao, t);

const po = (t, ...n) => {
    const {val: e, set: s} = fo();
    if (e != null) {
        return e;
    }
    t = qe(t) && !kf(t) ? Dc(t, ...n) : t;
    return s(t);
};

const $o = () => ({
    pending: ls(0),
    version: ls(0)
});

function q(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = A(t.container, n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.pending.value++;
    }
}

function R(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return t.getHostProp(n, mr);
}

function P(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    zo(t, yr, null);
}

function A(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return function e(t) {
        if (!__EXPERIMENTAL__.suspense) {
            return null;
        }
        return Uo(t, yr, null) || null;
    }(n) || R(t, n);
}

function M(t, n) {
    __EXPERIMENTAL__.suspense && zo(t, yr, n);
}

function N(t, n, e) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    M(n, e);
    const s = n.dirtyChildren;
    if (!s || s.length === 0) {
        return;
    }
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        N(t, o, R(t, o) || e);
    }
}

const mo = t => {
    if (t.En) {
        try {
            t.En();
        } catch (t) {
            ((t, ...n) => {
                be(!1, t, ...n);
            })(t);
        }
        t.En = null;
    }
};

function I(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    o || (o = Lc(e, s));
    const r = o.$;
    const i = o.m;
    Bo(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r._ : null;
        const l = Uo(i, fr, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = Uo(i, ar, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return ne(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i));
}

function C(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = Lc(t, n);
    typeof this === "string" && sf(of(e.$, this));
    const s = rf[0];
    return I(s, t, n, e);
}

function j(t) {
    return t.k === t.T ? t.q : null;
}

function O(t) {
    return t.R || j(t);
}

function F(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = j(t);
    return e === o ? null : e;
}

const yo = Object.prototype.hasOwnProperty;

function L(t, n, e, s, o, r) {
    import.meta.env.TEST && o && zo(n, vr, o);
    zo(n, e, r);
    ln(t, co(n.node, e, s, o, (n.flags & 512) !== 0));
}

function D(t, n, e, s) {
    return {
        $: t,
        M: n,
        N: e,
        j: s,
        O: [],
        L: [],
        D: [],
        k: null,
        R: null,
        W: null,
        q: null,
        T: null,
        U: null,
        X: null,
        B: null,
        H: null,
        J: null,
        Y: 0,
        G: 0,
        K: !0,
        Z: !1,
        tt: {
            nt: new ws({
                j: s,
                et: !0
            }),
            rt: new ws({
                j: s,
                et: !1
            })
        }
    };
}

function V(t, n, e, s, o) {
    const r = t ?? D(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.M = e;
        t.N = s;
        t.j = o;
        t.tt.nt.data.j = o;
        t.tt.rt.data.j = o;
        t.L.length = 0;
        t.D.length = 0;
    })(r, n, e, s, o);
    return r;
}

const wo = (t, n, e, s, o, r, i) => W(V(i, t, n, o, r), e, s);

const bo = (t, n, e, s, o, r, i, c, l = !1, u) => W(V(u, t, n, i, c), e, s, o, r, l);

function W(t, n, e, s = wl(e), o = null, r = !1) {
    U(t, n, e, s, o, r);
    const i = Z(t);
    if (_r(i)) {
        return i.finally(() => {
            tt(t);
        });
    }
    tt(t);
}

function U(t, n, e, s = wl(e), o = null, r = !1) {
    const i = t.Z;
    t.Z = r || i;
    t.k = e;
    t.W = null;
    t.R = s;
    t.q = o;
    t.T = e;
    H(t, n, !0);
    try {
        if (t.k.flags & 32) {
            return;
        }
        for (;t.O.length; ) {
            for (;t.Y < t.G; ) {
                if (typeof t.J === "string") {
                    bt(t, t.J);
                } else if (typeof t.J === "number") {
                    bt(t, t.J + "");
                } else if (t.J && typeof t.J === "object") {
                    if (Ss(t.J)) {
                        const n = t.J.type;
                        if (typeof n === "string") {
                            rt(t);
                            at(t, t.J, n);
                            const e = t.J.constProps && yo.call(t.J.constProps, br) || yo.call(t.J.varProps, br);
                            e ? t.W || nt(t, !1) : Q(t, t.J.children, !0);
                        } else if (typeof n === "function") {
                            if (n === Vs) {
                                rt(t);
                                $t(t, "F", t.J.key);
                                Q(t, t.J.children, !0);
                            } else if (n === zs) {
                                rt(t);
                                G(t) || Q(t, t.J.children, !0);
                            } else if (n === _t) {
                                Y(t);
                                Q(t, t.J.children, !0, !1);
                            } else if (n === Bs) {
                                et(t);
                            } else if (n === Qs) {
                                et(t);
                            } else {
                                rt(t);
                                mt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.J)) {
                        Q(t, t.J, !1);
                    } else if (Gl(t.J)) {
                        $t(t, "S", null);
                        const n = t.J instanceof ys ? t.J.it() : t.J;
                        const e = t.R?.[di]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof ys && (s = Rt(e, n));
                        if (!s) {
                            const e = t.W || t.R;
                            Q(t, z(t, () => Uc(n, e, ".", t.$)), !0);
                        }
                    } else if (_r(t.J)) {
                        $t(t, "A", null);
                        t.L.push(t.J, t.W || t.R);
                    }
                } else {
                    t.J === Xs || bt(t, "");
                }
                X(t);
            }
            et(t);
            K(t);
            B(t);
        }
    } finally {
        t.Z = i;
    }
}

function z(t, e) {
    try {
        return e();
    } catch (s) {
        if (_r(s)) {
            const o = s.then(() => n(e));
            t.L.push(o, t.W || t.R);
            return null;
        }
        throw s;
    }
}

function X(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.Y++;
    if (t.Y < t.G) {
        t.J = t.H[t.Y];
    } else if (t.O.length > 0 && t.O[t.O.length - 1] === !1) {
        return B(t);
    }
    t.W !== null ? t.W = null : t.R = F(t, t.R);
}

function Q(t, n, e, s = !0) {
    if (s && (n == null || e && xe(n) && n.length === 0)) {
        nt(t);
        return;
    }
    H(t, n, e);
    if (e) {
        const n = t.Z || !!t.W || !wl(t.R);
        t.Z = n;
        t.B = null;
        t.U = null;
        t.X = null;
        t.k = t.W || t.R;
        t.R = wl(t.k);
        t.W = null;
    }
    t.K = !1;
}

function B(t) {
    const n = t.O.pop();
    if (n) {
        t.Z = t.O.pop();
        t.B = t.O.pop();
        t.U = t.O.pop();
        t.X = t.O.pop();
        t.W = t.O.pop();
        t.R = t.O.pop();
        t.k = t.O.pop();
    }
    t.J = t.O.pop();
    t.G = t.O.pop();
    t.Y = t.O.pop();
    t.H = t.O.pop();
    X(t);
}

function H(t, n, e) {
    t.O.push(t.H, t.Y, t.G, t.J);
    e && t.O.push(t.k, t.R, t.W, t.X, t.U, t.B, t.Z);
    t.O.push(e);
    if (Array.isArray(n)) {
        t.Y = 0;
        t.G = n.length;
        t.H = n;
        t.J = t.G > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.Y = 0;
        t.J = null;
        t.H = null;
        t.G = 0;
    } else {
        t.Y = 0;
        t.J = n;
        t.H = null;
        t.G = 1;
    }
}

function J(t) {
    if (t.W) {
        return O(t);
    }
    return F(t, t.R) || j(t);
}

function Y(t) {
    const n = t.J;
    const e = n.key;
    t.R = Uo(t.k, e, n => Go(t.$.rootVNode, n));
    t.R = t.R && t.R.flags & 32 ? null : t.R;
    if (t.R == null) {
        t.W = Co();
        zo(t.W, Fe, e);
        t.W.slotParent = t.k;
        zo(t.k, e, t.W);
    }
}

function G(t) {
    const n = t.J;
    const e = Xl(t.k);
    const s = function o(t, n) {
        const e = t.J;
        const s = e.constProps;
        if (s && typeof s == "object" && yo.call(s, "name")) {
            const e = s.name;
            if (n && e instanceof ys) {
                return Uc(e, n, ":", t.$);
            }
        }
        return Gi(e, "name") || "";
    }(t, e);
    const r = Gi(n, mr) || null;
    const i = e ? Uo(e, s, null) : null;
    if (i == null) {
        t.W = Co();
        zo(t.W, Fe, s);
        zo(t.W, mr, r);
        N(t.$, t.W, r);
        e && zo(e, s, t.W);
        fl(t.M, t.k, t.W, J(t));
        return !1;
    }
    if (i === t.R) {} else {
        const n = i.parent;
        t.W = i;
        zo(t.W, Fe, s);
        zo(t.W, mr, r);
        N(t.$, t.W, r);
        e && zo(e, s, t.W);
        cl(t.M, t.W);
        fl(t.M, t.k, t.W, J(t));
        n && Oo(n) && !n.firstChild && $l(n) === tr && dl(t.M, n.parent, n, !0);
    }
    return !0;
}

function K(t) {
    const n = t.B;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            Et(t.$, t.M, e, t.N);
            dl(t.M, t.k, e, !0);
        }
        n.clear();
        t.B = null;
    }
    t.R = null;
}

function Z(t) {
    for (;t.L.length; ) {
        const n = t.L.shift();
        const e = t.L.shift();
        if (_r(n)) {
            return n.then(n => {
                U(t, n, e);
                return Z(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return Z(t);
            });
        }
        U(t, n, e);
    }
    if (t.D.length) {
        const n = t.D.splice(0);
        return Promise.all(n).then(() => Z(t));
    }
}

function tt(t) {
    t.M = null;
    t.N = null;
}

function nt(t, n = !0) {
    const e = t.R && wl(t.R);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            Et(t.$, t.M, s, t.N);
            s = s.nextSibling;
        }
        pl(t.M, t.R, e, n);
    }
}

function et(t) {
    const n = j(t);
    if (t.R !== null && t.R !== n) {
        for (;t.R && t.R !== n; ) {
            const n = t.R;
            t.R = F(t, t.R);
            if (t.k === n.parent) {
                Et(t.$, t.M, n, t.N);
                dl(t.M, t.k, n, !0);
            }
        }
    }
}

function rt(t) {
    if (t.R !== null && Do(t.R)) {
        const n = t.R;
        t.R = F(t, t.R);
        dl(t.M, t.k, n, !0);
    }
}

function it(t, n, e) {
    if (Gl(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw Re(15, [ e ]);
}

function st(t, e, s, o, r) {
    return n(() => Uc(o, e, s, t, r));
}

function ot(t, n, e, s, o) {
    const i = t.j;
    const c = s.then(t => x(n, e, r(e, t, i), o));
    t.D.push(c);
}

function lt(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(Ke, "html");
    }
}

function ut(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function ct(t, n, e, s) {
    const i = function c(t, n) {
        const e = hl(t.k, !0);
        const s = o(e, n);
        const r = import.meta.env.TEST ? t.$.document : document;
        const i = s.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(s.elementNamespace, n);
        t.W = Mo(i, n);
        t.W.flags |= s.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.W;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (qr(n)) {
                ft(n, o, i, l, t);
                continue;
            }
            if (n === "ref" && it(o, i, s)) {
                continue;
            }
            Gl(o) && (o = st(t.$, t.W, n, o, t.tt.nt));
            if (_r(o)) {
                ot(t, i, n, o, u);
                continue;
            }
            if (n === br) {
                lt(i, o);
                continue;
            }
            if (e === "textarea" && n === "value" && ut(i, o)) {
                continue;
            }
            x(i, n, r(n, o, t.j), u);
        }
    }
    const a = n.key;
    a && (t.W.key = a);
    if (t.j) {
        const e = yo.call(n.varProps, "class") || n.constProps && yo.call(n.constProps, "class");
        e || i.setAttribute("class", t.j);
    }
    il(t.M, t.k, t.W, O(t));
}

function ft(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(I.bind(null, n));
                }
            } else {
                e && s.push(I.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = I.bind(null, n));
    }
    t.charAt(2) !== "e" && Xo(o.M, s, t, "");
    (function i(t, n) {
        const e = import.meta.env.TEST ? t.$.document.defaultView : window;
        e && (e._qwikEv ||= []).push(n);
    })(o, r);
}

function at(t, n, e) {
    if (t.Z) {
        ct(t, n, e, null);
    } else {
        const s = t.R && Oo(t.R);
        const o = s && e === $l(t.R);
        const r = n.key;
        const i = s && t.R.key;
        if (o && r === i) {
            dt(t, e, r);
        } else {
            const s = ht(e, r);
            pt(t, e, r, s, t.k) && ct(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.W || t.R;
    s && function r(t, n, e, s) {
        t.Z || Bo(t.$, n);
        const o = n.props;
        for (const r in e) {
            const i = e[r];
            if (o && yo.call(o, r)) {
                const e = o[r];
                if (i !== e) {
                    if (i instanceof ys && e instanceof ys && qt(i, e)) {
                        continue;
                    }
                    vo(t, n, r, i, s);
                }
            } else {
                i != null && vo(t, n, r, i, s);
            }
        }
        if (o) {
            for (const r in o) {
                yo.call(e, r) || r.charAt(0) === ":" || qr(r) || vo(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const vo = (t, n, e, s, o) => {
    if (qr(e)) {
        ft(e, s, n.node, n, t);
        return;
    }
    if (e === fr || e === ar) {
        zo(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (it(s, t, o)) {
            return;
        }
    }
    const i = n[di]?.get(e);
    if (Gl(s)) {
        const o = s instanceof ys ? s.it() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && mn(t.$, i);
        const r = n;
        s = st(t.$, r, e, o, t.tt.rt);
    } else {
        i && mn(t.$, i);
    }
    if (_r(s)) {
        const o = n;
        const i = s.then(n => {
            L(t.M, o, e, n, t.j, r);
        });
        t.D.push(i);
        return;
    }
    L(t.M, n, e, s, t.j, r);
};

function ht(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function dt(t, n, e) {
    const s = ht(n, e);
    if (s && t.B?.has(s)) {
        t.B.delete(s);
        return !0;
    }
    return !1;
}

function pt(t, n, e, s, o, r) {
    t.W = function i(t, n, e) {
        let s = null;
        if (t.U === null) {
            const o = t.R;
            if (o) {
                const s = Oo(o) ? $l(o) : null;
                const r = vt(o) || gt(o, t.$._);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.U = new Map;
            t.X = [];
            const r = j(t);
            let i = t.R;
            for (;i && i !== r; ) {
                const o = Oo(i) ? $l(i) : null;
                const r = vt(i) || gt(i, t.$._);
                s === null && r == e && o == n ? s = i : r === null ? t.X.push(o, i) : t.U.set(ht(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.X.length; e += 2) {
                if (t.X[e] === n) {
                    s = t.X[e + 1];
                    t.X.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ht(n, e);
            const r = t.U.get(o);
            if (r) {
                s = r;
                t.U.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.R) {
                    const n = Oo(t.R) ? $l(t.R) : null;
                    const e = vt(t.R) || gt(t.R, t.$._);
                    if (e != null) {
                        const s = ht(n, e);
                        t.B ||= new Map;
                        t.B.set(s, t.R);
                        t.U?.delete(s);
                    }
                }
                return;
            }
            const e = j(t);
            let s = t.R;
            for (;s && s !== n && s !== e; ) {
                const n = Oo(s) ? $l(s) : null;
                const e = vt(s) || gt(s, t.$._);
                if (e != null) {
                    const o = ht(n, e);
                    t.B ||= new Map;
                    t.B.set(o, s);
                    t.U?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.W) {
        s || fl(t.M, o, t.W, O(t));
        t.R = t.W;
        t.W = null;
        return !1;
    }
    if (s != null) {
        const n = t.B?.get(s) || null;
        if (n) {
            t.B.delete(s);
            if (r && t.R) {
                const n = vt(t.R) || gt(t.R, t.$._);
                if (n != null) {
                    const e = Oo(t.R) ? $l(t.R) : null;
                    const s = ht(e, n);
                    if (s != null) {
                        t.B ||= new Map;
                        t.B.set(s, t.R);
                    }
                }
            }
            n !== t.R && fl(t.M, o, n, O(t));
            t.R = n;
            t.W = null;
            return !1;
        }
    }
    return !0;
}

function $t(t, n, e) {
    const s = n === "F";
    const o = vt(t.R);
    const r = t.R && Vo(t.R);
    const i = r && o === e && (!s || !!e);
    if (i) {
        dt(t, null, o);
        return;
    }
    if (e === null || t.Z) {
        sl(t.M, t.k, t.W = Co(), J(t));
        t.W.key = e;
        return;
    }
    if (pt(t, null, e, ht(null, e), t.k, !0)) {
        sl(t.M, t.k, t.W = Co(), J(t));
        t.W.key = e;
    }
}

function mt(t, n) {
    const e = n[Sf];
    let s = t.W || t.R;
    const o = t.J;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.st;
        const l = gt(s, t.$._);
        const u = o.key || c;
        const f = vt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                dt(t, null, u);
            } else {
                yt(t, s, i, n);
                s = t.W;
                r = !0;
            }
        } else {
            if (pt(t, null, u, u, t.k)) {
                yt(t, s, i, n);
                r = !0;
            }
            s = t.W || t.R;
        }
        if (s) {
            const e = Uo(s, lr, t.$._);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = St(n[Di], e[Di], e[Ui], s, !1);
                        o ||= t;
                        const r = St(n[Vi], e[Vi], e[Ui], s, !0);
                        o ||= r;
                        e[Wi] = n[Wi];
                    } else if (n) {
                        zo(t, lr, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    yt(t, s, i, n);
                    s = t.W;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                zo(s, Ce, i);
                s.flags &= -33;
                on(t.$, s, 4, t.N);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new gs(_t, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (T(n)) {
                            const t = n;
                            ge(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (Ss(n) && Gi(n, Fe) || "") + "";
                const i = ve(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            Q(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = vt(s);
        const i = e === r;
        const c = gt(s, t.$._);
        const l = c == null;
        if (s && !l || !s) {
            wt(t);
            s = t.W;
        } else if (i) {
            dt(t, null, e);
        } else {
            pt(t, null, e, e, t.k) && wt(t);
            s = t.W || t.R;
        }
        if (s) {
            let e = s;
            for (;e && (!Vo(e) || Uo(e, Ce, null) === null); ) {
                e = e.parent || Xl(e);
            }
            const r = Us(t.$, s, e || t.$.rootVNode, n, o.props);
            t.L.push(r, s);
        }
    }
}

function yt(t, n, e, s) {
    n && $n(t.$, n);
    sl(t.M, t.k, t.W = Co(), J(t));
    const o = t.J;
    zo(t.W, Ce, e);
    zo(t.W, lr, s);
    t.W.key = o.key;
}

function wt(t) {
    sl(t.M, t.k, t.W = Co(), J(t));
    const n = t.J;
    zo(t.W, lr, n.props);
    n.key && (t.W.key = n.key);
}

function bt(t, n) {
    if (t.R !== null) {
        const e = Ul(t.R);
        if (e === 3) {
            if (n !== ml(t.R)) {
                yl(t.M, t.R, n);
                return;
            }
            return;
        }
    }
    il(t.M, t.k, t.W = Io((import.meta.env.TEST ? t.$.document : document).createTextNode(n), n), O(t));
}

function vt(t) {
    if (t == null || Do(t)) {
        return null;
    }
    return t.key;
}

function gt(t, n) {
    if (t == null || Do(t)) {
        return null;
    }
    const e = Uo(t, Ce, n);
    return e ? e.st : null;
}

function _t() {}

function St(t, n, e, s, o = !0) {
    if (kt(t) && kt(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === Xe) {
                continue;
            }
            if (!n || t[s] !== n[s]) {
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = t[s]);
                    const o = Yi(e, s);
                    o || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === Xe) {
                continue;
            }
            if ((!t || !yo.call(t, s)) && o) {
                delete n[s];
                const t = Yi(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function kt(t) {
    if (!t) {
        return !0;
    }
    return ci(t);
}

function Et(t, n, e, s = null) {
    let o = e;
    if (Do(e)) {
        Tt(o);
        return;
    }
    let r = null;
    for (;;) {
        const i = o.flags;
        if (i & 3) {
            $n(t, o);
            Tt(o);
            const r = i & 2 && Uo(o, Ce, null) !== null;
            if (r) {
                const e = t.getHostProp(o, ur);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (Ee(r)) {
                            const n = Jl(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                on(t, o, 64, s);
                                continue;
                            }
                            (r instanceof ji || au(r)) && $n(t, r);
                            (n || r instanceof Li) && mo(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (T(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? Go(t.rootVNode, e) : e;
                                let c = wl(o);
                                for (;c; ) {
                                    Et(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                xt(n, o);
                            }
                        }
                    }
                }
            }
            const c = Wo(o);
            if (c) {
                if (o === e) {
                    const t = wl(o);
                    if (t) {
                        fn(t, () => {});
                        return;
                    }
                }
            } else {
                const t = wl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            i & 4 && Tt(o);
        }
        if (o === e) {
            return;
        }
        const c = o.nextSibling;
        if (c) {
            o = c;
            continue;
        }
        r = o.parent;
        for (;r; ) {
            if (r === e) {
                return;
            }
            const t = r.nextSibling;
            if (t) {
                o = t;
                break;
            }
            r = r.parent;
        }
        if (r == null) {
            return;
        }
    }
}

function xt(t, n) {
    const e = n.parent;
    if (e) {
        const s = e.flags;
        s & 1 && $l(e) === tr && dl(t, e, n, !0);
    }
}

function Tt(t) {
    t.flags |= 32;
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ot === t.ot && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.lt, t.lt);
}

function Rt(t, n) {
    if (!(n instanceof ys)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof ys && qt(s, n)) {
            return !0;
        }
    }
    return !1;
}

function Pt(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function At(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Pt(t[c], c, r, s);
    }
    return i;
}

function Mt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Nt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = wl(e);
    const f = D(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return bo(c, n, At(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        pl(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return bo(c, n, At(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        pl(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let m = e.lastChild;
    for (;m !== $ && d >= h && m.key === (a[d] ??= r(o[d], d)); ) {
        m = m.previousSibling;
        d--;
    }
    const y = m ? m.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== y; ) {
            const s = t.nextSibling;
            dl(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (m === $) {
        const t = y;
        return bo(c, n, At(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const w = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const v = function g(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, m);
    const _ = [];
    const S = new Map;
    for (let t = 0; t < v.length; t++) {
        const s = v[t];
        const o = s.key;
        if (b.has(o)) {
            S.set(o, _.length);
            _.push(s);
        } else {
            dl(n, e, s, !0);
        }
    }
    const k = new Int32Array(w);
    k.fill(-1);
    const E = [];
    const x = [];
    for (let t = 0; t < w; t++) {
        const n = S.get(a[h + t]);
        if (n !== void 0) {
            k[t] = n;
            x.push(t);
            E.push(n);
        }
    }
    const T = new Uint8Array(w);
    const q = function R(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(E);
    for (let t = 0; t < q.length; t++) {
        T[x[q[t]]] = 1;
    }
    let P = d;
    let A = y;
    const M = () => {
        for (;P >= h; ) {
            const t = P - h;
            if (T[t] === 1) {
                A = _[k[t]];
                P--;
                continue;
            }
            const r = k[t];
            if (r !== -1) {
                const t = _[r];
                const s = A === null ? e.lastChild === t : t.nextSibling === A;
                s || fl(n, e, t, A);
                A = t;
                P--;
                continue;
            }
            let l = P;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (T[t] === 1 || k[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = P - l + 1;
            const d = bo(c, n, At(o, a, null, i, l, P), e, A, A, s, null, !0, f);
            return kr(d, () => {
                const t = Mt(e, A, u);
                A = t;
                P = l - 1;
                return M();
            });
        }
    };
    return M();
}

function It(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, ur);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof Hl) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = Bl(s, n, t);
                _r(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Ct(t, n) {
    const e = t.props ||= {};
    e[Ti] = n;
}

function jt(t, n) {
    const e = t.props ||= {};
    e[qi] = n;
}

function Ot(t, n) {
    t.dirty &= -257;
    const e = function s(t) {
        const n = t.props;
        return n?.[qi] ?? null;
    }(t);
    if (!e) {
        return;
    }
    jt(t, null);
    const o = t;
    const r = o.parent;
    const i = o.nextSibling;
    const c = el(n, document, o, e);
    const l = Oo(o) && r || o;
    const u = l === o ? null : i;
    il(n, l, c, u);
    t.dirty &= -33;
    t.dirtyChildren = null;
}

function Ft(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[Ti];
    }(t);
    if (!r) {
        return;
    }
    Ct(t, null);
    Gl(r) && (r = r.value);
    return wo(n, e, r, o, s, null);
}

function Lt(t, e, s, o) {
    t.dirty &= -5;
    const r = t;
    const i = e.getHostProp(r, Ce);
    if (!i) {
        return;
    }
    const c = e.getHostProp(r, lr) || null;
    const l = Sr(() => Us(e, r, r, i, c), t => {
        const i = e.getHostProp(r, Ue);
        return n(() => wo(e, s, t, r, o, Tr(i)));
    }, t => {
        e.handleError(t, r);
    });
    if (_r(l)) {
        return l;
    }
    return;
}

function Dt(t, n, e, s, o, r = null) {
    n.push(co(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Vt(t, n) {
    t.dirty &= -9;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[xi] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        Gl(e) && (e = e.value);
        const r = s.isConst;
        Dt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[xi];
    })(t);
}

function Wt(t, n) {
    t.dirty &= -65;
    const e = n.getHostProp(t, ur);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof Hl && n.h & 16) {
            n.h &= -17;
            const t = n;
            mo(t);
        }
    }
}

function Ut(t, e) {
    t.dirty &= -17;
    const s = e.getHostProp(t, Ri);
    if (!s) {
        return;
    }
    const o = s.ut;
    const r = re();
    r.$ = e;
    return kr(n(() => te.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return nu(e, s, o);
        }
    });
}

function zt(t, n, e, s) {
    t.dirty &= -129;
    const o = t;
    const r = n.getHostProp(o, lr) || null;
    if (!r) {
        return;
    }
    let i = Ki(r, "items");
    Gl(i) && (i = Dc(i));
    const c = Ki(r, "key$");
    const l = Ki(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Nt(n, e, o, s, i, u, f);
    }
    return kr(c.resolve(), t => kr(l.resolve(), r => Nt(n, e, o, s, i, t, r)));
}

let go = null;

const _o = (t, n, e) => {
    go || (go = t.insertBefore);
    go.call(t, n, e);
};

function Xt(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const i = () => {
        if (s) {
            if (s.length === 1) {
                _o(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                _o(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof ro) {
            if (n === l.parent && e === l.beforeTarget) {
                s || (s = []);
                s.push(l.target);
                o.add(l.target);
                continue;
            }
            if (!s) {
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (n === l.parent) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (o.has(l.target) || e && l.target === e || n && l.target === n) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            _o(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof to) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            l.target.remove();
            continue;
        }
        if (l instanceof no) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof eo) {
            l.target.nodeValue = l.text;
        } else if (l instanceof io) {
            const t = l.target;
            const e = l.attrName;
            const s = l.attrValue;
            const o = s != null ? r(e, s, l.scopedStyleIdPrefix) : null;
            const c = o == null || o === !1;
            if (So(t, e)) {
                t[e] = ko(o);
            } else if (e === br) {
                n === t && i();
                t.innerHTML = o;
                t.setAttribute(Ke, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : x(t, e, o, l.isSvg);
            }
        }
    }
    i();
}

const So = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const ko = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const Eo = (t => () => queueMicrotask(t))(Ht);

const To = Ur(Ht);

let qo = !1;

function Qt() {
    if (!qo) {
        qo = !0;
        Eo();
    }
}

function Bt() {
    if (!qo) {
        qo = !0;
        To();
    }
}

function Ht() {
    qo = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (Jt(e, n)) {
            Bt();
            return;
        }
    }
}

function Jt(t, n) {
    const e = import.meta.env.TEST ? Wr() : oe;
    const s = d(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        Yt(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 511)) {
            __EXPERIMENTAL__.suspense && P(l);
            h(r, s, Zt(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 64) {
                Wt(l, r);
            } else if (l.dirty & 32) {
                const n = Kt(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -512;
            h(r, s, Zt(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = It(l, r, s);
            } else if (l.dirty & 2) {
                e = Ft(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Lt(l, r, i, t);
            } else if (l.dirty & 128) {
                e = zt(l, r, i, t);
            } else if (l.dirty & 8) {
                Vt(l, i);
            } else if (l.dirty & 16) {
                e = Ut(l, r);
            } else if (l.dirty & 32) {
                const n = Kt(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 256 && Ot(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && _r(e)) {
            q(s, l);
            s.promise = e;
            c(t, r);
            const n = l;
            e.catch(t => {
                r.handleError(t, n);
            }).finally(() => {
                s.promise = null;
                f(t, r);
                Qt();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    Yt(r, t, s, e);
}

function Yt(t, n, e, s) {
    if (!(n.dirty & 511)) {
        a(n, t);
        s || function o(t, n) {
            const e = d(t);
            const s = e.journal;
            if (s && s.length > 0) {
                Xt(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                let s;
                for (let n = 0; n < e.length; n++) {
                    const o = e[n];
                    const r = Bl(o, t, o.ct);
                    _r(r) && (s = s ? s.then(() => r) : r);
                }
                s && (n.extraPromises ||= []).push(s);
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.pending.value = Math.max(0, e.pending.value - 1);
                e.version.value++;
            }
        })(e);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                Gt(t);
            });
            return;
        }
        Gt(t);
    }
}

function Gt(t) {
    t.ft();
}

function Kt(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -33;
        P(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = Zt(o[0], s, t);
    h(t, n, i);
    return i;
}

function Zt(t, n, e) {
    if (t === n) {
        if (n.dirty & 511) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 32 ? s = t.slotParent : t.parent && t.parent.dirty & 32 && (s = t.parent);
    if (!s) {
        if (n.dirty & 511) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 511) {
            if (e && tn(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -33;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && P(s);
    return Zt(s, n, e);
}

function tn(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    if (!n.props || !(mr in n.props) || !t.getHostProp(n, mr)) {
        return !1;
    }
    en(n) || nn(t, n, 0);
    return !0;
}

function nn(t, n, e) {
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        Ei.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    l(t, r);
    Qt();
    return r;
}

function en(t) {
    return (t.flags & 256) !== 0;
}

function rn(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 8 && function e(t, n) {
            n.dirty &= -9;
            const e = n.getProp(xi);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                Gl(e) && (e = e.value);
                const i = r(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, i);
            }
        }(t, n);
        n.dirty & 16 && Ut(n, t);
        if (n.dirty & 511) {
            const t = `A chore was scheduled on a host element that has already been streamed to the client.\n        This can lead to inconsistencies between Server-Side Rendering (SSR) and Client-Side Rendering (CSR).\n        \n        Problematic chore:\n          - Host: ${"" + n}\n          - Nearest element location: ${n.currentFile}\n        \n        This is often caused by modifying a signal in an already rendered component during SSR.`;
            we(t);
        }
        n.dirty &= -512;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(ur);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof Hl) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = Bl(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        _r(s) && (e = s);
    }
    if (n.dirty & 128) {
        const s = async function o(t, n) {
            n.dirty &= -129;
            const e = n;
            const s = t.getHostProp(e, lr) || null;
            if (!s) {
                return;
            }
            let o = Ki(s, "items");
            Gl(o) && (o = Dc(o));
            const r = await Ki(s, "key$").resolve();
            const i = await Ki(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -508;
    if (e) {
        return e;
    }
}

const Ro = [];

function sn(t) {
    for (let n = 0; n < Ro.length; n++) {
        const e = Ro[n];
        const s = Ro[n + 1] || t;
        s.dirty |= 32;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function on(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return import.meta.env.TEST ? Wr() : oe;
    }()) {
        const e = rn(t, n);
        _r(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 511;
    if ((i ? o & 511 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function e(t, n, s) {
            Ro.push(n);
            let o = R(t, n);
            let r = n.slotParent || n.parent;
            for (;r; ) {
                const e = r.dirty & 511;
                const i = en(r);
                __EXPERIMENTAL__.suspense && (o ||= R(t, r) || (e ? A(t, r) : null));
                if (r === s || e) {
                    M(n, o);
                    sn(r);
                    if (i) {
                        const t = d(r);
                        t.position !== r && (t.position = n);
                    }
                    Ro.length = 0;
                    return;
                }
                if (i) {
                    const t = d(r);
                    t.position !== r && (t.position = n);
                }
                Ro.push(r);
                r = r.slotParent || r.parent;
            }
            Ro.length = 0;
            ((t, ...n) => {
                const e = be(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(t, n, s);
        return;
    }
    if (c && c.dirty & 511) {
        M(n, R(t, n) || A(t, c));
        i && (c.dirty |= 32);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (en(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = d(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        en(n) ? M(n, R(t, n)) : function l(t, n) {
            Ro.push(n);
            let e = __EXPERIMENTAL__.suspense ? R(t, n) : null;
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const o = en(s);
                __EXPERIMENTAL__.suspense && (e ||= R(t, s) || (o ? A(t, s) : null));
                if (o) {
                    M(n, e);
                    sn(s);
                    Ro.length = 0;
                    return !0;
                }
                Ro.push(s);
                s = s.slotParent || s.parent;
            }
            M(n, e);
            Ro.length = 0;
            return !1;
        }(t, n) || nn(t, n, 0);
    }
}

function ln(t, n) {
    t.push(n);
}

const Po = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const Ao = t => {
    let n = null;
    return e => {
        n || (n = Po(e, t));
        return n.call(e);
    };
};

const Mo = (t, n, e = null) => {
    const s = new gi(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const No = t => {
    const n = new gi(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const Io = (t, n) => {
    const e = new _i(-4084, null, null, null, null, t, n);
    return e;
};

const Co = () => {
    const t = new vi(null, -4094, null, null, null, null, null, null);
    return t;
};

const jo = t => t instanceof bi;

const Oo = t => (t.flags & 1) === 1;

const Fo = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const Lo = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const Do = t => (t.flags & 4) === 4;

const Vo = t => (t.flags & 2) === 2;

const Wo = t => {
    const n = t.flags;
    return (n & 2) === 2 && Uo(t, Fe, null) !== null;
};

const ih = t => t;

const Uo = (t, n, e) => {
    if (Oo(t) || Vo(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const zo = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const Xo = (t, n, e, s, o = null) => {
    if (Oo(n)) {
        import.meta.env.TEST && o && zo(n, vr, o);
        zo(n, e, s);
        ln(t, co(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const Qo = t => {
    if (t.key) {
        return;
    }
    const n = Sl(t.node, wr);
    n && (t.key = n);
};

const Bo = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (qr(c)) {
                un(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== wr && c) {
                if (c.startsWith(Ke)) {
                    const t = i.value;
                    t === "html" ? zo(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && zo(e, "value", s.value);
                } else {
                    const t = i.value;
                    zo(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        Uo(e, fr, null) === null && Uo(e, ar, null) === null || (n.flags |= 64);
    }
};

const Ho = t => {
    if (t.bt === "_run") {
        const n = t.getCaptured()?.[0];
        if (Ae(n)) {
            return n;
        }
    }
    return t;
};

function un(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = Ho(qn(i[t], e));
        c.push(I.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function cn(t, n, e) {
    let s = wl(n);
    for (;s; ) {
        if (Do(s)) {
            Yo(t, s);
            e(s, n);
        } else {
            Oo(s) ? e(s, n) : cn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function fn(t, n) {
    let e = t;
    if (Do(t)) {
        n?.(t, null);
        return;
    }
    let s = null;
    for (;;) {
        if (n?.(e, s)) {
            return;
        }
        const o = wl(e);
        if (o) {
            e = o;
            continue;
        }
        if (e === t) {
            return;
        }
        const r = e.nextSibling;
        if (r) {
            e = r;
            continue;
        }
        s = e.parent;
        for (;s; ) {
            if (s === t) {
                return;
            }
            const n = s.nextSibling;
            if (n) {
                e = n;
                break;
            }
            s = s.parent;
        }
        if (s == null) {
            return;
        }
    }
}

const Jo = (t, n, e) => {
    let s = t;
    for (;e && s && Vo(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !Vo(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !Vo(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (Do(t) && e && Oo(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && Ll(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Yo = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = al(n, !0);
        const o = e.node;
        const r = Nl(s);
        let i = Jo(n, !1, !0);
        const c = Jo(n, !0, !0);
        const l = o || (c && Oo(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && Do(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                ln(t, uo(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = Jo(i, !1, !0);
        }
        i = n;
        for (;i && Do(i); ) {
            const n = Jo(i, !0, !0);
            const e = !n || !Do(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    ln(t, lo(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    ln(t, uo(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const Go = (t, n) => {
    let e = t;
    const s = t.node;
    const {qVNodeRefs: o} = s;
    let r = -1;
    let i;
    if (typeof n === "string") {
        r = parseInt(n);
        i = o.get(r);
    } else {
        i = n;
        const t = i.vNode;
        if (t) {
            return t;
        }
    }
    if (jo(i)) {
        e = i;
    } else {
        let t = i;
        const n = [ i ];
        for (;t && t !== s && !t.vNode; ) {
            t = t.parentElement;
            n.push(t);
        }
        t.vNode && (e = t.vNode);
        for (let t = n.length - 2; t >= 0; t--) {
            e = tl(e, n[t]);
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = n.length;
        let s = nl(n, t);
        let o = 0;
        for (;s < t; ) {
            const t = n.charCodeAt(s);
            o *= 26;
            if (t >= 97) {
                o += t - 97;
            } else {
                o += t - 65;
                e = Ko(e, o);
                o = 0;
            }
            s++;
        }
    }
    return e;
};

const Ko = (t, n) => {
    let e = wl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Zo = [];

const tl = (t, n) => {
    let e = wl(t);
    for (;e && (!(e instanceof gi) || e.node !== n); ) {
        if (Vo(e)) {
            const t = e.nextSibling;
            const n = wl(e);
            if (n) {
                t && Zo.push(t);
                e = n;
            } else {
                e = t || (Zo.length ? Zo.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Zo.pop();
        }
    }
    for (;Zo.length; ) {
        Zo.pop();
    }
    return e;
};

const nl = (t, n) => {
    let e = 0;
    for (;e < n; ) {
        if (!(t.charCodeAt(e) <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const el = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = Mo(o, "errored-host");
    if (Fo(e)) {
        fl(t, r, e, null);
    } else {
        const n = [];
        cn(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            fl(t, r, n[e], null);
        }
    }
    return r;
};

const rl = Xt;

const il = (t, n, e, s) => {
    const o = Oo(n);
    o && bl(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    ul(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : al(n, !1);
    l && !c && ln(t, uo(i, l, ol(t, n, s)?.node ?? null));
    ll(n, e, s);
    c && (e.flags |= 32);
};

const sl = (t, n, e, r) => {
    const i = Oo(n);
    i && bl(n);
    const c = e.parent;
    if (e === r) {
        if (c) {
            return;
        }
        r = null;
    }
    ul(t, c, n, e);
    const l = n.flags & 32;
    const u = !i && n.flags & 2048 ? n.props?.[je] : null;
    const f = u ? null : i ? n : hl(n, !1);
    const a = u || f?.node;
    const h = ol(t, n, r);
    const d = h?.node ?? null;
    const p = Wo(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const i = hl(n, !1);
        const c = ol(t, n, r)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(i, e);
        cn(t, e, n => {
            if (Do(n)) {
                ln(t, uo(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, r, i) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (Oo(c)) {
                                e = c.node;
                                const t = $l(c);
                                const l = c.parent;
                                const h = u == null ? n : l && hl(l, !0);
                                if (h) {
                                    const t = o(h, $l(c));
                                    r = t.elementNamespace;
                                    i = t.elementNamespaceFlag;
                                }
                                const d = wl(c);
                                a = s(e, t, r, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= i;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (gl(e)) {
                                    const t = Yn(e);
                                    if (t) {
                                        const n = wl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, i, l, u);
                    t && (n.node = t);
                }
                ln(t, uo(n.node, a, c));
            }
        });
    } else {
        a && !l && cn(t, e, n => {
            ln(t, uo(n.node, a, d));
        });
    }
    ll(n, e, r);
    l && (e.flags |= 32);
};

const ol = (t, n, e) => {
    let s = null;
    e == null ? Vo(n) && (s = Jo(n, !0, !1)) : s = Vo(e) ? Jo(e, !0, !0) : e;
    s && Do(s) && Yo(t, s);
    return s;
};

const ll = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const ul = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && dl(t, n, s, !1);
};

const cl = (t, n) => {
    let e = n;
    for (;e && Vo(e); ) {
        e = e.lastChild;
    }
    e && Do(e) && (e.flags & 8) === 0 && Yo(t, e);
};

const fl = (t, n, e, s) => {
    Fo(e) ? il(t, n, e, s) : sl(t, n, e, s);
};

const al = (t, n) => {
    for (;t && !Oo(t); ) {
        if (t.flags & 2048) {
            return t.props?.[je];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const hl = (t, n) => {
    for (;t && !Oo(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const dl = (t, n, e, s) => {
    Do(e) && Yo(t, e);
    if (s) {
        const s = Uo(n, br, null) !== null;
        if (s) {
            return;
        }
        Fo(e) ? ln(t, so(e.node)) : cn(t, e, n => {
            ln(t, so(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const pl = (t, n, e, s = !0) => {
    const o = al(n, !0);
    if (o && s) {
        if (Fo(n)) {
            ln(t, oo(n.node));
        } else {
            const e = hl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? ln(t, oo(o)) : cn(t, n, n => {
                ln(t, so(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const $l = t => {
    const n = ih(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = Ml(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = Al(t);
            switch (n) {
              case er:
                return 512;

              case rr:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const ml = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const yl = (t, n, e) => {
    Yo(t, n);
    n.text = e;
    ln(t, lo(n.node, e));
};

const wl = t => {
    if (Do(t)) {
        return null;
    }
    let n = t.firstChild;
    n === void 0 && (n = bl(t));
    return n;
};

const bl = n => {
    const e = ih(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && gl(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = Pl(e);
            const o = Nl(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                Qo(n);
                if (o) {
                    if (o.charCodeAt(0) === Ie && o.charCodeAt(1) === Ie) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = Il(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = zl(t);
                            return !n || n && pn(t);
                        };
                        let p = null;
                        Cl(e, ($, m, y, w, b) => {
                            if (Dl($())) {
                                for (;d(o); ) {
                                    o = Tl(o);
                                    if (!o) {
                                        throw Re(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;Dl($()); ) {
                                    t *= 10;
                                    t += y() - 48;
                                }
                                for (;t--; ) {
                                    const n = No(o);
                                    Qo(n);
                                    u(n);
                                    o = Tl(o);
                                    for (;zl(o) && pn(o); ) {
                                        o = Tl(o);
                                        if (!o && t > 0) {
                                            throw Re(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                zo(n, Ue, m());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                zo(n, Ce, m());
                            } else if ($() === 61) {
                                h || (h = Jn(s));
                                const t = m();
                                h.Rn(parseInt(t), n);
                            } else if ($() === 62) {
                                zo(n, lr, m());
                            } else if ($() === 64) {
                                const e = w(b + 1) === Ie;
                                let s;
                                if (e) {
                                    y();
                                    s = decodeURI(t(m()));
                                    y();
                                } else {
                                    s = m();
                                }
                                n.key = s;
                            } else if ($() === 91) {
                                zo(n, ur, m());
                            } else if ($() === 94) {
                                zo(n, cr, m());
                            } else if ($() === 96) {
                                h || (h = Jn(s));
                                hn(n, m(), h);
                            } else if ($() === 63) {
                                h || (h = Jn(s));
                                n.slotParent = Go(h.rootVNode, m());
                            } else if ($() === 93) {
                                zo(n, ze, m());
                            } else if ($() === 123) {
                                y();
                                u(Co());
                                Wl.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === Ie) {
                                const e = t(m());
                                const s = t(m());
                                zo(n, e, s);
                            } else if ($() === 125) {
                                y();
                                n.lastChild = c;
                                r = Wl.pop();
                                l = Wl.pop();
                                c = Wl.pop();
                                i = Wl.pop();
                                n = Wl.pop();
                            } else if ($() === 126) {
                                const e = t(m());
                                zo(n, Fe, e);
                            } else {
                                for (;zl(o) && pn(o); ) {
                                    o = Tl(o);
                                }
                                const t = o && kl(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;Vl($()); ) {
                                    n += y() - 97;
                                    n *= 26;
                                }
                                n += y() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new _i(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = Jn(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return Il(n, s);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let vl = null;

const gl = t => {
    vl || (vl = t.hasAttribute);
    return vl.call(t, Ke);
};

let _l = null;

const Sl = (t, n) => {
    _l || (_l = t.getAttribute);
    return _l.call(t, n);
};

const kl = Ao("nodeType");

const El = t => {
    const n = kl(t);
    return n === 3 || n === 1;
};

let xl = null;

const Tl = t => {
    xl || (xl = Po(t, "nextSibling"));
    Rl || (Rl = Po(t, "firstChild"));
    for (;t; ) {
        t = xl.call(t);
        if (t !== null) {
            const n = kl(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(Ye)) {
                    return an(t, He, xl, Rl);
                }
                if (t.nodeValue?.startsWith(Je)) {
                    return an(t, [ He, Ge ], xl, Rl);
                }
                if (n?.startsWith(Ke)) {
                    for (;t && (t = xl.call(t)) && (kl(t) !== 8 || !t.nodeValue?.startsWith(Ze)); ) {}
                }
            }
        }
    }
    return t;
};

function an(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = ql(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const ql = Ao("parentNode");

let Rl = null;

const Pl = t => {
    Rl || (Rl = Po(t, "firstChild"));
    t = t && Rl.call(t);
    if (t && kl(t) === 8 && t.nodeValue?.startsWith(Ye)) {
        xl || (xl = Po(t, "nextSibling"));
        return an(t, He, xl, Rl);
    }
    for (;t && !El(t); ) {
        t = Tl(t);
    }
    return t;
};

const Al = Ao("namespaceURI");

const Ml = Ao("nodeName");

const Nl = Ao("ownerDocument");

const Il = (t, n, e) => {
    let s = null;
    const o = () => {
        for (;zl(r) && pn(r); ) {
            r = Tl(r);
        }
    };
    let r = n;
    o();
    let i = null;
    for (;r; ) {
        const n = kl(r);
        let e = null;
        if (n === 3) {
            e = Io(r, r.textContent ?? void 0);
        } else if (n === 1) {
            e = No(r);
            Qo(e);
        }
        if (e) {
            e.parent = t;
            i && (i.nextSibling = e);
            e.previousSibling = i;
            i = e;
        }
        s || (t.firstChild = s = i);
        r = Tl(r);
        o();
    }
    t.lastChild = i || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        Cl(e, (e, s) => {
            if (e() === 61) {
                n || (n = Jn(t.node));
                const e = s();
                n.Rn(parseInt(e), t);
            } else if (e() === 96) {
                n || (n = Jn(t.node));
                hn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function hn(t, n, e) {
    if (t[di]) {
        const s = t[di];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e._(n));
    } else {
        Object.defineProperty(t, di, {
            get() {
                const s = e._(n);
                t[di] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, di, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const Cl = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e);
    }
};

const jl = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        Bo(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(wr) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const Ol = (t, n) => {
    let e = Fl(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = Fl(e);
    }
    return !1;
};

const Fl = t => t.parent || t.slotParent;

const Ll = t => {
    if (t === null || Vo(t)) {
        return null;
    }
    return t.node;
};

function dn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (Oo(e)) {
                        const t = Gn(e.node);
                        if (!t) {
                            return null;
                        }
                        return Yn(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (Do(i)) {
            c.push(gn(ml(i)));
        } else if (Vo(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = jl(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== Me && e !== vr) {
                        const t = Uo(i, e, null);
                        s.push(" " + e + "=" + gn(t));
                    }
                }
            }
            const l = (o ? "[34m" : "") + (Ne[Uo(i, Me, null) || "V"] || Ne.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = wl(i);
            u && c.push("  " + dn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (Oo(i)) {
            const s = $l(i);
            const l = [];
            en(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? jl(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = Uo(i, n, null);
                l.push(" " + n + "=" + gn(e));
            }
            const f = Ll(i);
            if (f) {
                const t = Nl(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + gn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + gn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (Lo(i) || e) {
                const e = wl(i);
                e && c.push("  " + dn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const Dl = t => 48 <= t && t <= 57;

const Vl = t => 97 <= t && t <= 122;

function pn(t) {
    return !t.hasAttribute(wr) || t.nodeName === "STYLE" && (t.hasAttribute(Ue) || t.hasAttribute(De));
}

const Wl = [];

const Ul = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw Re(26, [ n ]);
};

const zl = t => t && typeof t == "object" && kl(t) === 1;

const Xl = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!Vo(t) || Uo(t, Ce, null) === null); ) {
            const e = t.slotParent;
            const s = Vo(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function $n(t, n) {
    jo(n) && Oo(n) && bl(n);
    const e = n[di];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        mn(t, n);
    }
    e.clear();
}

function mn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof Li) {
            wn(s, n);
        } else if (s instanceof ji) {
            yn(t, s, n);
        } else if (ns(s)) {
            const t = s[Ui];
            bn(t, n);
        } else if (t.ht.has(s)) {
            const e = t.ht.get(s);
            const o = ou(e);
            bn(o, n);
        }
    }
    e.clear();
}

function yn(t, n, e) {
    const s = n.ut;
    s && s.has(e) && s.delete(e);
    if (n instanceof ys && !s?.size) {
        n.m = void 0;
        $n(t, n);
    }
}

function wn(t, n) {
    const e = t.ut;
    e && e.has(n) && e.delete(n);
    const s = t.dt;
    s && s.has(n) && s.delete(n);
    const o = t.$t;
    o && o.has(n) && o.delete(n);
    t.yt();
}

function bn(t, n) {
    const e = t?.ut;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Ql = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = fo();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Hl(6 | i, r, o.m, t, void 0, null);
    s(c);
    const l = o.$;
    const {Ft: u} = o;
    const f = kr(u, () => Bl(c, l, o.m));
    _r(f) && (o.Ft = f);
};

const Bl = (t, n, e) => {
    const s = t.Pn;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let r = null;
    const i = kr(((t, n) => {
        const e = t.An;
        if (e) {
            return e;
        }
        const s = t.En;
        if (!s) {
            return;
        }
        t.En = null;
        try {
            const e = s();
            if (_r(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.An === s && (t.An = void 0);
                });
                t.An = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = re(n.Ct, e, "qTask");
        s.$ = n;
        const i = t.wt.getFn(s, () => $n(n, t));
        const c = Ci(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.En = () => {
                            t.En = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    _r(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return Sr(() => i(u), l, s => {
            if (_r(s)) {
                return s.then(() => {
                    t.Pn === r && (t.Pn = null);
                    return Bl(t, n, e);
                });
            }
            o(s);
        });
    });
    if (_r(i)) {
        r = i.finally(() => {
            t.Pn === r && (t.Pn = null);
        });
        t.Pn = r;
        return r;
    }
    return i;
};

class Hl extends pi {
    h;
    Bt;
    ct;
    wt;
    It;
    En;
    An;
    Pn=null;
    constructor(t, n, e, s, o, r) {
        super();
        this.h = t;
        this.Bt = n;
        this.ct = e;
        this.wt = s;
        this.It = o;
        this.En = r;
    }
}

const Jl = t => t instanceof Hl;

function vn(t, n) {
    const e = Jn(n);
    typeof this === "string" && sf(of(e, this));
    const s = rf[0];
    s.h |= 4;
    on(e, s.ct, 1);
}

const Yl = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const Gl = t => t instanceof ji;

const Kl = (t, n) => {
    t.add(n);
};

const Zl = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const tu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Jl(e) ? o = e.wt : e instanceof Oi ? o = e.Zt : s === ":" && (o = n.getHostProp(e, Ce));
        o && n.serializationCtx.At.add(o);
    }
};

const nu = (t, n, e) => {
    const s = import.meta.env.TEST ? !Wr() : !oe;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (Jl(o)) {
                o.h |= 4;
                on(t, o.ct, 1);
            } else if (o instanceof ji) {
                o.invalidate();
            } else if (r === ":") {
                on(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Ct(o, n);
                    on(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof ws) {
                    const e = i.data;
                    const c = {
                        isConst: e.et,
                        scopedStyleIdPrefix: e.j,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[xi];
                            if (!o) {
                                o = new Map;
                                s[xi] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(xi);
                        if (!n) {
                            n = new Map;
                            t.setProp(xi, n);
                        }
                        n.set(r, c);
                    }
                    on(t, o, 8);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const eu = t => Ee(t) && typeof t[Sc] === "function";

const ru = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const iu = [];

function gn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Jl(t)) {
            return `Task(${gn(t.wt)})`;
        }
        if (Ae(t)) {
            return `Qrl(${t.bt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (iu.includes(t)) {
                return "*";
            }
            try {
                iu.push(t);
                if (Array.isArray(t)) {
                    return jo(t) ? "(" + (Uo(t, Me, null) || "vnode") + ")" : t.map(gn);
                }
                if (Gl(t)) {
                    return t instanceof ys ? "WrappedSignal" : t instanceof Oi ? "ComputedSignal" : "Signal";
                }
                if (au(t)) {
                    return "Store";
                }
                if (Ss(t)) {
                    return su(t);
                }
                if (jo(t)) {
                    return "(" + (Uo(t, Me, null) || "vnode") + ")";
                }
            } finally {
                iu.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const su = t => {
    if (Ss(t)) {
        if (typeof t.type === "function") {
            const n = t.type[Sf];
            if (n) {
                const [t] = n;
                return "Component(" + t.bt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + gn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += su(e);
                    }
                } else {
                    n += su(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const ou = t => t[Ni];

const lu = t => t?.[Mi] || null;

const uu = (t, n) => {
    const e = ou(t);
    e && e.force(n);
};

const cu = (t, n) => {
    const e = ou(t);
    if (e) {
        return (e.ut?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const fu = t => lu(t) || t;

const au = t => Mi in t;

function _n(t, n, e) {
    return new Proxy(n, new du(e, t || null));
}

const hu = (t, n, e) => {
    if (ke(t) && e) {
        let s = e.ht.get(t);
        if (!s) {
            s = _n(e, t, n);
            e.ht.set(t, s);
        }
        return s;
    }
    return t;
};

class du {
    h;
    $;
    ut=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = lu(this);
        nu(this.$, this, En(n, t, this.ut));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === Mi) {
                return t;
            }
            if (n === Ni) {
                return this;
            }
            return t[n];
        }
        const e = jc();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.Ot;
            o && Sn(t, Array.isArray(t) ? Ii : n, this, o);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && Ee(s) && !Object.isFrozen(s) && !au(s) && !Object.isFrozen(t)) {
            return hu(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? fu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && kn(n, s, t, this);
        } else {
            kn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || nu(this.$, this, En(t, n, this.ut));
        return !0;
    }
    has(t, n) {
        if (n === Mi) {
            return !0;
        }
        if (typeof n === "string") {
            const e = jc();
            if (e) {
                const s = e.Ot;
                s && Sn(t, Array.isArray(t) ? Ii : n, this, s);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = jc();
        const e = n?.Ot;
        e && Sn(t, Ii, this, e);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function Sn(t, n, e, s) {
    const o = e.ut ||= new Map;
    let r = o.get(n);
    if (!r) {
        r = new Set;
        o.set(n, r);
    }
    Kl(r, s);
    Zl(s, t);
    (import.meta.env.TEST ? !Mc(e.$) : oe) && tu(s, e.$);
}

function kn(t, n, e, s) {
    e[t] = n;
    const o = En(e, t, s.ut);
    o && nu(s.$, s, o);
}

function En(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(Ii);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const pu = Symbol();

const $u = [ void 0, null, !0, !1, "", Qi, Bi, Pi, Ii, Xi, zs, Vs, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER ];

const mu = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER" ];

const yu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription" ];

function xn(t, n, e) {
    let s = n.bt;
    let o = n.vt;
    const r = Vr();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => Ae(t) && t.bt == Pe)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.gt(null, 0, e) + "";
    } else {
        o || (o = t._t(n.st));
        if (!o) {
            throw Re(14, [ n.bt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    c && c.length > 0 && (l = c.map(n => "" + t.St(n)).join(" "));
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function Tn(t, n, e, s) {
    return ff(t, n, null, null, e, s);
}

function qn(t, n) {
    const [e, s, o] = t.split("#");
    return Tn(e, s, o || null, n);
}

class wu {
    Mn;
    Nn=0;
    Et=[];
    In=0;
    Cn=new Set;
    jn=new Map;
    On;
    Fn=new Map;
    Nt;
    Ln=typeof Temporal !== "undefined";
    constructor(t) {
        this.Mn = t;
        this.Nt = t.Nt;
    }
    async serialize() {
        await this.outputRoots();
    }
    outputArray(t, n, e) {
        this.Nt.write("[");
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Nt.write(fi) : s = !0;
            e(t[n], n);
        }
        this.Nt.write("]");
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    output(t, n, e) {
        if (typeof n === "number") {
            this.Nt.write(t + fi + n);
        } else if (typeof n === "string") {
            const e = this.stringNeedsJsonEscape$(n) ? JSON.stringify(n) : '"' + n + '"';
            this.Nt.write(t + fi);
            let s = -1;
            let o = 0;
            for (;(s = e.indexOf("</", o)) !== -1; ) {
                this.Nt.write(e.slice(o, s));
                this.Nt.write("<\\/");
                o = s + 2;
            }
            this.Nt.write(o === 0 ? e : e.slice(o));
        } else {
            this.Nt.write(t + fi);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Mn.getSeenRef(t);
        const o = !e && this.jn.get(t);
        if (!s) {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Mn.Dn(t, this.On, n);
            }
            s = this.Mn.St(t, !0);
        }
        if (s.On) {
            if (this.On) {
                this.Mn.Vn(s);
            } else {
                this.Mn.Vn(s, n);
                t = this.Mn.Wn[n];
            }
        }
        if (typeof o === "number") {
            this.Et[o] = s.Bt;
            this.jn.delete(t);
        }
        const r = t instanceof Eu ? t.Un : s.Bt;
        if (!this.On && r === n) {
            return s;
        }
        this.output(1, r);
    }
    writeValue(t, n) {
        if (vc(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                t.length === 0 ? this.output(3, 4) : (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, "" + t);
                break;

              case "symbol":
                t === Pi ? this.output(3, 7) : t === Ii ? this.output(3, 8) : t === Xi ? this.output(3, 9) : t === pu && this.output(3, 0);
                break;

              case "function":
                if (t === zs) {
                    this.output(3, 10);
                } else if (t === Vs) {
                    this.output(3, 11);
                } else if (Ae(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = xn(this.Mn, t, !0);
                        let o;
                        if (n !== "") {
                            o = `${this.Mn.St(n)}#${this.Mn.St(e)}${s ? "#" + s : ""}`;
                            const r = this.Fn.get(o);
                            if (r) {
                                const t = this.Mn.St(r);
                                this.output(1, t);
                                return;
                            }
                            this.Fn.set(o, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!kf(t)) {
                        throw Re(34, [ "" + t ]);
                    }
                    {
                        const [n] = t[Sf];
                        this.Mn.zn.add(n.bt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === Qi) {
                    this.output(3, 5);
                } else if (t === Bi) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof Eu) {
                    this.output(1, t.Un);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.On;
                        this.On = e;
                        this.writeObjectValue(t);
                        this.On = n;
                    }
                }
                break;

              default:
                throw Re(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (ns(t)) {
            const n = t[Wi];
            this.output(38, [ Su(n), n.varProps, n.constProps, t[Ui].ut ]);
        } else if (t instanceof ws) {
            this.output(39, [ t.data.j, t.data.et ]);
        } else if (t instanceof Ai) {
            this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (au(t)) {
            const n = ou(t);
            const e = lu(t);
            const s = n.h;
            const o = n.ut;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Mn.ht.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (eu(t)) {
            const n = t[Sc](t);
            if (_r(n)) {
                const t = this.resolvePromise(n, (t, n) => new bu(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.On.Bt;
                this.On = this.On.On;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        vc(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Mn.Xn(t)) {
            t.Qn.vnodeData[0] |= 16;
            this.output(11, t.Qn.id);
        } else if (t instanceof ji) {
            if (t instanceof rs) {
                const n = function e(t, n) {
                    if (n === Pi) {
                        return n;
                    }
                    return kr(t.Zt.resolved || t.Zt.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && Sc in n && (e = n[Sc](n));
                        e === void 0 && (e = Pi);
                        return e;
                    });
                }(t, t.Gt);
                if (_r(n)) {
                    const e = this.resolvePromise(n, (n, e) => new bu(34, n, e, t.ut, t.Zt));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Zt, t.ut, n ]);
                }
                return;
            }
            if (t instanceof ys) {
                this.output(31, [ ...Rn(this.Mn, t), t.h, t.m, ...t.ut || [] ]);
            } else if (t instanceof Oi) {
                let n = t.Gt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = vc(t.Gt);
                const i = t instanceof Li;
                const c = i && t.xt !== 0 ? t.xt : void 0;
                const l = i && t.dn !== 1 ? t.dn : void 0;
                const u = i && t.$n !== 0 ? t.$n : void 0;
                const f = i && t.h & -25 || void 0;
                o || r ? n = Pi : e ? n = t.Gt : s && (n = Pi);
                const a = [ t.Zt, t.ut ];
                if (i) {
                    a.push(t.dt, t.$t, t.an);
                    a.push(f || void 0);
                }
                n === Pi && c === void 0 && l === void 0 && u === void 0 || a.push(n === void 0 ? pu : n);
                if (i) {
                    a.push(c);
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Gt;
                const e = [ n === void 0 ? pu : n ];
                t.ut && e.push(...t.ut);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (this.Ln && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.Ln && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.Ln && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.Ln && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.Ln && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.Ln && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.Ln && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.Ln && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else if (t instanceof RegExp) {
            this.output(8, "" + t);
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.Mn.Bn(t)) {
            const n = this.Mn.St(t);
            this.Mn.Hn(t, "q:id", n + "");
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                vu(e, t => this.Mn.St(t));
                e[0] |= 16;
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    const s = n.vnodeData;
                    s && (s[0] |= 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, "" + t);
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (Ss(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof Hl) {
            const n = [ t.wt, t.h, t.Bt, t.ct, t.It ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (_r(t)) {
            const n = this.resolvePromise(t, (t, n) => new bu(24, t, n));
            this.output(2, n);
        } else if (t instanceof bu) {
            if (t.Jn === 34) {
                if (t.wt) {
                    this.output(34, [ t.wt, t.ut, t.Yn ]);
                } else {
                    if (!t.Gn) {
                        console.error(t.Yn);
                        throw Re(33);
                    }
                    {
                        const n = this.On.Bt;
                        this.On = this.On.On;
                        this.writeValue(t.Yn, n);
                    }
                }
            } else {
                this.output(24, [ t.Gn, t.Yn ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof _u) {
            const n = t.Kn;
            if (this.getSeenRefOrOutput(n, this.On.Bt, !0)) {
                let t = this.jn.get(n);
                if (t === void 0) {
                    t = this.In++;
                    this.jn.set(n, t);
                    this.Et[t] = -1;
                }
                this.output(2, t);
            }
        } else {
            if (!jo(t)) {
                throw Re(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.In++;
        t.then(s => {
            this.Cn.delete(t);
            this.Et[e] = this.Mn.St(n(!0, s));
        }).catch(s => {
            this.Cn.delete(t);
            this.Et[e] = this.Mn.St(n(!1, s));
        });
        this.Cn.add(t);
        return e;
    }
    async outputRoots() {
        this.Nt.write("[");
        const {Wn: t} = this.Mn;
        for (;this.Nn < t.length || this.Cn.size; ) {
            this.Nn !== 0 && this.Nt.write(fi);
            let n = !1;
            for (;this.Nn < t.length; this.Nn++) {
                n ? this.Nt.write(fi) : n = !0;
                this.writeValue(t[this.Nn], this.Nn);
            }
            if (this.Cn.size) {
                try {
                    await Promise.race(this.Cn);
                } catch {}
            }
        }
        if (this.Et.length) {
            let t = this.Et.length - 1;
            for (;t >= 0 && this.Et[t] === -1; ) {
                t--;
            }
            if (t >= 0) {
                this.Nt.write(fi);
                this.Nt.write(14 + fi);
                const n = t === this.Et.length - 1 ? this.Et : this.Et.slice(0, t + 1);
                this.outputArray(n, !0, t => {
                    this.Nt.write(t + "");
                });
            }
        }
        this.Nt.write("]");
    }
}

class bu {
    Jn;
    Gn;
    Yn;
    ut;
    wt;
    constructor(t, n, e, s, o) {
        this.Jn = t;
        this.Gn = n;
        this.Yn = e;
        this.ut = s;
        this.wt = o;
    }
}

const vu = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (gu(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || t === lr && ci(s)) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const gu = t => typeof t === "object" && t !== null && !ci(t);

function Rn(t, n) {
    n.kt && n.kt[0] === "{" && (n.kt = `(${n.kt})`);
    const e = t.gt(n.kt, n.lt.length, n.ot);
    return [ e, n.lt ];
}

class _u {
    Kn;
    constructor(t) {
        this.Kn = t;
    }
}

const Su = t => new _u(t);

let ku = () => !1;

class Eu {
    Un;
    constructor(t) {
        this.Un = t;
    }
}

class xu {
    NodeConstructor;
    DomRefConstructor;
    _t;
    Hn;
    ht;
    Nt;
    Zn=new Map;
    te=new Map;
    ne=[];
    Wn=[];
    Tt=new Set;
    At=new Set;
    Pt=new Set;
    zn=new Set;
    ee;
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this._t = e;
        this.Hn = s;
        this.ht = o;
        this.Nt = r;
        this.ee = new wu(this);
    }
    async Mt() {
        return await this.ee.serialize();
    }
    getSeenRef(t) {
        return this.Zn.get(t);
    }
    Dn(t, n, e) {
        const s = {
            Bt: e,
            On: n
        };
        this.Zn.set(t, s);
        return s;
    }
    re(t) {
        const n = [];
        for (;t.On; ) {
            n.unshift(t.Bt);
            t = t.On;
        }
        n.unshift(t.Bt);
        return n.join(" ");
    }
    Vn(t, n) {
        const e = this.re(t);
        n === void 0 && (n = this.Wn.length);
        this.Wn[n] = new Eu(e);
        t.On = null;
        t.Bt = n;
    }
    St(t, n = !1) {
        let e = this.Zn.get(t);
        let s;
        if (e) {
            e.On && this.Vn(e);
            s = e.Bt;
        } else {
            s = this.Wn.length;
            e = {
                Bt: s
            };
            this.Zn.set(t, e);
            this.Wn.push(t);
        }
        return n ? e : s;
    }
    Bn(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    Xn(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    ie(t) {
        const n = this.Zn.get(t);
        return n && (n.On ? void 0 : n.Bt);
    }
    gt(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || "" + e);
        let o = this.te.get(t);
        if (o === void 0) {
            o = this.ne.length;
            this.te.set(t, o);
            if (s) {
                this.ne.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.ne.push(e += ")=>" + t);
            }
        }
        return o;
    }
}

const Tu = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = {
            write: n => {
                t.push(n);
            },
            toString: () => t.join("")
        };
    }
    ku = n ? t => t instanceof n : () => !1;
    return new xu(t, n, e, s, o, r);
};

const qu = (t, n) => t[n];

const Ru = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        au(t) && (t = lu(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!Ru(Dc(qu, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!Ru(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Jl(t)) {
            return !0;
        }
        if (ns(t)) {
            return !0;
        }
        if (_r(t)) {
            return !0;
        }
        if (Ss(t)) {
            return !0;
        }
        if (eu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof ws) {
            return !0;
        }
        if (ku?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (Ae(t) || kf(t) || t === zs || t === Vs) {
            return !0;
        }
    } else if (t === Xi || t === Pi || t === Ii) {
        return !0;
    }
    return !1;
};

const Pu = (t, n) => {
    let e = jo(t) ? dn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (Ee(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let Au = !1;

const Mu = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (Au = !0);
            const n = `{${Ee(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${Pu(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = Iu(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${Mu(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${Nu(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = Au ? "" : `(${JSON.stringify(t).length} chars)`;
        Au = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const Nu = t => yu[t] || `Unknown(${t})`;

const Iu = t => mu[t] || `Unknown(${t})`;

function Pn(t, n) {
    const e = (t, n) => t === 1 && typeof n === "string";
    const s = t => t === 14;
    const o = n => {
        const e = t[n + 1].split(" ");
        let s = t;
        let o = 1;
        let r = 0;
        let i = 0;
        let c = null;
        for (let n = 0; n < e.length; n++) {
            c = s;
            r = parseInt(e[n], 10) * 2;
            i = r + 1;
            o = s[r];
            s = s[i];
            if (o === 1) {
                const n = s;
                const e = n * 2;
                o = t[e];
                s = t[e + 1];
            }
        }
        if (c) {
            c[r] = 1;
            c[i] = n / 2;
        }
        t[n] = o;
        t[n + 1] = s;
    };
    for (let r = 0; r < t.length; r += 2) {
        e(t[r], t[r + 1]) ? o(r) : s(t[r]) && (n.Et = t[r + 1]);
    }
}

const Cu = new WeakMap;

const ju = new Map;

const Ou = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t._(e);

      case 2:
        if (!t.Et) {
            return Xi;
        }
        const s = t.Et[e];
        return s === -1 || s === void 0 ? Xi : t._(s);

      case 14:
        return e;

      case 3:
        return $u[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const [s, o, r] = e.split("#");
                const i = t._(s);
                const c = t._(o);
                n = Tn(i, c, r || null, t);
            } else {
                n = Tn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new Hl(-1, -1, null, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return _f(null);

      case 30:
        return new ji(t, 0);

      case 31:
        return new ys(t, null, null, null);

      case 32:
        return new Oi(t, null);

      case 33:
        return new Li(t, null, void 0, {});

      case 34:
        return new rs(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = Ou(t, s, o);
            const i = hu(r, 0, t);
            ac(s) && ju.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new gs(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        Cu.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        const l = e.length;
        const u = l >>> 2;
        const f = l & 3;
        const a = u * 3 + (f ? f - 1 : 0);
        return new Uint8Array(a);

      case 38:
        return $(null);

      case 10:
        return An(t, e);

      case 11:
        const h = An(t, e);
        if (jo(h)) {
            bl(h);
            return Ll(h);
        }
        throw Re(17, [ typeof h ]);

      case 39:
        return new ws({});

      case 40:
        return new Ai(null, null, null, null);

      default:
        throw Re(18, [ n ]);
    }
};

function An(t, n) {
    return n ? t.rootVNode ? Go(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Fu = (t, n, e) => {
    let s = null;
    let o = null;
    if (qe(t)) {
        o = t;
    } else {
        if (!Te(t)) {
            throw Re(7, [ t ]);
        }
        s = t;
    }
    return ff(s, n, null, o, e);
};

const Lu = (t, n, e) => ff(null, n, t, null, e);

const Du = (t, n) => ff(null, t, null, null, n);

const Vu = (t, n, e) => {
    const s = Du(t, e);
    s.se(n);
    return s;
};

const Wu = (t, n, e, s) => {
    const o = Fu(t, n, s);
    o.se(e);
    return o;
};

const Uu = (t, n, e, s) => {
    const o = Lu(t, n, s);
    o.se(e);
    return o;
};

const zu = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

function Mn(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Xu = (t, n, e) => new ys(null, t, n, e || null);

class Qu {
    oe;
    ht;
    Ct;
    _;
    Lt;
    le=0;
    ue=null;
    ce=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.Lt = t;
        this.Ct = n;
        this.oe = ai;
        this.ht = new WeakMap;
        this._ = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return Uc(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return Tu(t, n, e, this.setHostProp.bind(this), this.ht, s);
    }
    ft() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

class Bu {}

function Nn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function In(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === Bu) {
                    const t = o.pop();
                    await n(() => o.push(t()));
                    continue;
                }
                if (typeof e === "function") {
                    e === Promise ? o.push(await o.pop()) : await e.apply(t);
                    continue;
                }
                Cn(t, r, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                _r(n) && await n;
            }
        }
    })();
}

function Cn(t, n, e, s) {
    if (e == null) {
        t.textNode("");
    } else if (typeof e === "boolean") {
        t.textNode("");
    } else if (typeof e === "number") {
        t.textNode(e + "");
    } else if (typeof e === "string") {
        t.textNode(e);
    } else if (typeof e === "object") {
        if (Array.isArray(e)) {
            for (let t = e.length - 1; t >= 0; t--) {
                n(e[t]);
            }
        } else if (Gl(e)) {
            (function s(t, n) {
                const e = n instanceof ys ? n.it() : n;
                if (e instanceof Li) {
                    const n = e.xt;
                    if (n && !(e.h & 256)) {
                        t.St(e);
                        t.Tt.add(e);
                    }
                }
            })(t.serializationCtx, e);
            t.openFragment(Bi);
            const o = t.getOrCreateLastNode();
            const r = e instanceof ys ? e.it() : e;
            n(t.closeFragment);
            n(() => Uc(r, o, ".", t));
            n(Bu);
        } else if (_r(e)) {
            t.openFragment(Bi);
            n(t.closeFragment);
            n(e);
            n(Promise);
            n(() => t.streamHandler.flush());
        } else if (function o(t) {
            return !!t[Symbol.asyncIterator];
        }(e)) {
            n(async () => {
                for await (const n of e) {
                    await In(t, n, {
                        currentStyleScoped: s.currentStyleScoped,
                        parentComponentFrame: s.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const o = e;
            const r = o.type;
            if (typeof r === "string") {
                (function e(t, n) {
                    const e = Gi(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(o, s.currentStyleScoped);
                let i = null;
                const c = t.openElement(r, o.key, o.varProps, o.constProps, s.currentStyleScoped, i, !!(o.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (r === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (r === "body") {
                    n(t.additionalBodyNodes);
                } else if (!t.isHtml && !t._didAddQwikLoader && !t.qt) {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    t._didAddQwikLoader = !0;
                }
                const l = o.children;
                l != null && n(l);
            } else if (qe(r)) {
                if (r === Vs) {
                    const e = o.key != null ? {
                        [or]: o.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = o.children;
                    s != null && n(s);
                } else if (r === zs) {
                    const e = s.parentComponentFrame;
                    if (e) {
                        const r = e.componentNode.id || "";
                        const i = {};
                        const c = Gi(o, mr);
                        c && (i[mr] = c);
                        i["q:sparent"] = r;
                        t.openProjection(i);
                        const l = e.componentNode;
                        const u = t.getOrCreateLastNode();
                        const f = function a(t, n, e) {
                            const s = n.constProps;
                            if (s && typeof s == "object" && "name" in s) {
                                const n = s.name;
                                if (n instanceof ys) {
                                    return Uc(n, t, ":", e);
                                }
                            }
                            return Gi(n, "name") || "";
                        }(l, o, t);
                        i[Fe] = f;
                        n(Nn(s, s.currentStyleScoped, s.parentComponentFrame));
                        n(t.closeProjection);
                        const h = o.children || null;
                        const d = e.consumeChildrenForSlot(u, f) || h;
                        h && d !== h && t.addUnclaimedProjection(e, "", h);
                        n(d);
                        n(Nn(s, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = Bi;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (r === Bs) {
                    t.commentNode(Gi(o, "data") || "");
                } else if (r === Js) {
                    t.streamHandler.flush();
                    const e = o.children;
                    let r;
                    r = qe(e) ? e({
                        async write(n) {
                            await In(t, n, {
                                currentStyleScoped: s.currentStyleScoped,
                                parentComponentFrame: s.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : e;
                    n(r);
                    _r(r) && n(Promise);
                } else if (r === Qs) {
                    t.htmlNode(Gi(o, "data"));
                } else if (r === Hs) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(o.children);
                } else if (kf(r)) {
                    const e = {};
                    t.openComponent(e);
                    const i = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(o.children, s.currentStyleScoped, s.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[Sf];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(Ce, o);
                        s.setProp(lr, r);
                        n.key !== null && s.setProp(or, n.key);
                        return Us(t, s, s, o, r);
                    })(t, o, r);
                    n(Nn(s, s.currentStyleScoped, s.parentComponentFrame));
                    n(t.closeComponent);
                    if (_r(l)) {
                        n(async () => {
                            const t = await l;
                            const e = Tr(i.getProp(Ue));
                            n(t);
                            n(Nn(s, e, c));
                        });
                    } else {
                        n(l);
                        const t = Tr(i.getProp(Ue));
                        n(Nn(s, t, c));
                    }
                } else {
                    const e = {
                        [or]: o.key
                    };
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = t.getParentComponentFrame();
                    const i = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Us(t, o, n, e, s.props);
                    })(t, s && s.componentNode, r, o);
                    n(i);
                    _r(i) && n(Promise);
                }
            }
        }
    }
}

const Hu = () => rf;

const Ju = async t => {
    const [n, e] = rf;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = _n(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Yu = (t, n) => {
    const {val: e, set: s, iCtx: o} = fo();
    if (e) {
        return e;
    }
    const r = ff(null, "_rsc", Ju, null, [ t, {} ], o.$);
    const i = ss(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const Gu = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (_r(t)) {
        return t.then(n, s);
    }
    const o = Ku(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return _r(i) ? i.then(n, s) : n(i);
};

const Ku = t => t && t.__brand === "resource";

function jn(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o = (o == null ? "" : o + "|") + t;
    };
    const c = n => {
        n.bt.startsWith("_") || !n.Rt?.length && !s || (n = ff(null, "_run", C, null, [ n ]));
        return xn(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (Ae(o)) {
                i(c(o));
                On(t, n, o);
            } else if (o != null) {
                const e = jn(t, n, o, s);
                e && i(e);
            }
        }
    } else if (Ae(r)) {
        o = c(r);
        On(t, n, r);
    }
    return o;
}

function On(t, n, e) {
    const s = Ar(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.Pt.add(r);
        t.At.add(e);
    }
}

const Zu = (t, n, e) => {
    ec(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const tc = (t, n, e) => {
    ec(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const nc = (t, n, e) => {
    ec(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const ec = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = rc();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + Pr(i), e, s);
            }
        } else {
            r(t + Pr(n), e, s);
        }
    }
};

const rc = () => {
    const t = Fc();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, dr);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, dr, s);
    }
    let o = t.$.getHostProp(e, pr);
    o === null && (o = 0);
    t.$.setHostProp(e, pr, o + 1);
    let r = t.$.getHostProp(e, $r);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, $r, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const ic = function(t, n) {
    if (!t.detail.files.some(t => n.getAttribute("data-qwik-inspector")?.startsWith(t))) {
        return;
    }
    if (typeof this === "string") {
        const t = Jn(n);
        sf(of(t, this));
    }
    const e = rf[0];
    const s = Jn(n);
    on(s, e, 4);
    const o = n.ownerDocument;
    o.__hmrDone = o.__hmrT;
};

let sc;

function Fn() {
    const t = jc();
    if (!t) {
        return;
    }
    sc ||= Lu(ic, "_hmr");
    const n = t.m;
    const e = sc.w([ n ]);
    tc("qHmr", e);
}

function Ln(t, n, e, s, o) {
    const r = Co();
    zo(r, Fe, o);
    r.parent = n;
    zo(n, o, r);
    zo(r, Ce, e);
    zo(r, lr, s);
    r.dirty = 4;
    nn(t, r, 1);
    return r;
}

function Dn(t, n) {
    zo(t, je, n);
    t.flags |= 2048;
}

function Vn(t, n, e) {
    zo(n, lr, e);
    on(t, n, 4);
}

function Wn(t, n, e, s) {
    zo(n, s, null);
    const o = [];
    Et(t, o, e);
    rl(o);
    if (e.flags & 2048) {
        const t = Uo(e, je, null);
        t && t.replaceChildren();
        zo(e, je, null);
        e.flags &= -2049;
    }
}

let oc = Promise.resolve();

const lc = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const uc = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !lc.has(t));
};

const cc = (t, n, e, s) => {
    if (e === 0) {
        return;
    }
    e !== 4 && Array.isArray(s) && (s = fc(t, s));
    switch (e) {
      case 4:
        fc(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!uc(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 28:
        const o = n;
        const r = s;
        o.wt = r[0];
        o.h = r[1];
        o.Bt = r[2];
        o.ct = r[3];
        o.It = r[4];
        break;

      case 29:
        n[Sf][0] = s[0];
        break;

      case 35:
        {
            const e = fu(n);
            const o = ju.get(e);
            if (o) {
                ju.delete(e);
                cc(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = ou(n);
            c.h = r;
            c.ut = i;
            Xn(c.ut, e);
            break;
        }

      case 30:
        {
            const t = n;
            const e = s;
            t.Gt = e[0];
            t.ut = new Set(e.slice(1));
            zn(t.ut, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ot = t.getSyncFn(o[0]);
            e.lt = o[1];
            e.Gt = Pi;
            e.h = o[2];
            e.h |= 1;
            e.m = o[3];
            e.ut = new Set(o.slice(4));
            (function r(t) {
                if (t.m !== null && jo(t.m)) {
                    const n = t.m;
                    const e = t.ut;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (Te(e)) {
                                const o = Uo(n, e, null);
                                if (o !== null) {
                                    t.Gt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = wl(n);
                        e && n.firstChild === n.lastChild && Do(e) && (t.Gt = ml(e));
                    }
                }
            })(e);
            zn(e.ut, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Zt = e[0];
            e[1] && (t.ut = new Set(e[1]));
            e[2] && (t.dt = new Set(e[2]));
            e[3] && (t.$t = new Set(e[3]));
            e[4] && (t.an = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.fn = !0);
            const o = e.length > 6;
            o && (t.Gt = e[6]);
            t.Gt === Pi && (t.h |= 1);
            const r = e[7] ?? 0;
            t.expires = Math.abs(r);
            r < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.dn = e[8] ?? 1;
                t.pn = [];
            }
            t.$n = e[9] ?? 0;
            zn(t.ut, t);
            zn(t.dt, t);
            zn(t.$t, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.Zt = r[0];
            const i = o.Zt.resolve(t).catch(() => {});
            oc = oc.finally(() => i);
            r[1] && (o.ut = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Gt = r[2]);
            e !== 34 && o.Gt !== Pi && (o.h &= -2);
            zn(o.ut, o);
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                n[t[e]] = t[e + 1];
            }
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = Cu.get(t);
            e ? r(o) : i(o);
            break;
        }

      case 27:
        const i = n;
        const c = atob(s);
        let l = 0;
        for (let t = 0; t < c.length; t++) {
            const n = c[t];
            i[l++] = n.charCodeAt(0);
        }
        break;

      case 38:
        const u = n;
        const f = s;
        let a = f[0];
        if (a === Xi) {
            a = new gs(Vs, f[1], f[2], null, 0, null);
            a._proxy = u;
        }
        u[Wi] = a;
        const h = u[Ui];
        h.ut = f[3];
        Xn(h.ut, u);
        break;

      case 39:
        {
            const t = n;
            t.data.j = s[0];
            t.data.et = s[1];
            break;
        }

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            (function o(t) {
                const n = import.meta.env.TEST ? Wr() : oe;
                const e = t.consumer;
                if (n && !e) {
                    return;
                }
                e[di] ||= new Map;
                e[di].set(t.property, t);
            })(t);
            break;
        }

      default:
        throw Re(16, [ e ]);
    }
};

const fc = (t, n, e = Array(n.length / 2)) => {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = Un(t, n[s], n[s + 1]);
    }
    return e;
};

function Un(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = Ou(t, n, e);
    ac(n) && cc(t, s, n, e);
    return s;
}

function zn(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function Xn(t, n) {
    if (t) {
        for (const [, e] of t) {
            zn(e, n);
        }
    }
}

const ac = t => t >= 23 || t === 4 || t === 5;

const hc = new WeakMap;

const dc = Symbol();

const pc = (t, n) => {
    if (!Array.isArray(n) || jo(n) || (t => Ee(t) && dc in t)(n)) {
        return n;
    }
    let e = hc.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new $c(t, n));
        hc.set(n, e);
    }
    return e;
};

class $c {
    $;
    fe;
    ae;
    constructor(t, n) {
        this.$ = t;
        this.fe = n;
        this.ae = this.fe.length / 2;
    }
    get(t, n, e) {
        if (n === dc) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.ae) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.fe[o];
        const i = this.fe[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = Ou(c, r, i);
        Reflect.set(t, n, l);
        this.fe[o] = 0;
        this.fe[o + 1] = l;
        ac(r) && cc(c, l, r, i);
        return l;
    }
    has(t, n) {
        if (n === dc) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === dc) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.fe.length / 2) {
            return o;
        }
        const i = r * 2;
        this.fe[i] = 0;
        this.fe[i + 1] = e;
        return !0;
    }
}

async function Qn(t) {
    const n = Tu(null, null, () => "", () => {}, new WeakMap);
    n.St(t);
    await n.Mt();
    return "" + n.Nt;
}

function Bn(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = function s(t) {
        let n;
        const e = {
            _: t => Hn(t, n),
            getSyncFn: () => () => {},
            ht: new WeakMap,
            element: null,
            Et: null
        };
        Pn(t, e);
        n = pc(e, t);
        e.It = n;
        return e;
    }(n);
    return Un(e, n[0], n[1]);
}

function Hn(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

const mc = (t, n) => {
    const e = new WeakSet;
    return Dc(yc, t, e, "_", n);
};

const yc = (t, n, e, s) => {
    const o = fu(t);
    if (o == null) {
        return t;
    }
    if (bc(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (Gl(o)) {
            return t;
        }
        if (Ru(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (_r(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (xe(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw Re(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw Re(3, [ o ]);
                    }
                    yc(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof bi) {
                return t;
            }
            if (ke(o)) {
                for (const [t, s] of Object.entries(o)) {
                    yc(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw Re(3, [ i ]);
    }
    return t;
};

const wc = /*#__PURE__*/ new WeakSet;

const bc = t => {
    if (Ee(t) || qe(t)) {
        return !wc.has(t) && !(_c in t);
    }
    return !0;
};

const vc = t => !!t && (Ee(t) || typeof t === "function") && (wc.has(t) || _c in t);

const gc = t => {
    (Ee(t) && t !== null || typeof t === "function") && wc.add(t);
    return t;
};

const _c = Symbol();

const Sc = Symbol();

const kc = t => /*#__PURE__*/ Object.freeze({
    id: Pr(t)
});

const Ec = (t, n) => {
    const {val: e, set: s, iCtx: o} = fo();
    if (e !== void 0) {
        return;
    }
    fe && Tc(t);
    fe && mc(n);
    o.$.setContext(o.m, t, n);
    s(1);
};

const xc = (t, n) => {
    const {val: e, set: s, iCtx: o} = fo();
    if (e !== void 0) {
        return e;
    }
    fe && Tc(t);
    const r = o.$.resolveContext(o.m, t);
    if (typeof n === "function") {
        return s(te(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw Re(8, [ t.id ]);
};

const Tc = t => {
    if (!Ee(t) || typeof t.id !== "string" || t.id.length === 0) {
        throw Re(11, [ t ]);
    }
};

const qc = t => {
    const n = Oc();
    const e = n.m;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const Rc = /*#__PURE__*/ kc("qk-error");

const Pc = t => 33 <= t && t <= 46;

const Ac = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Pc(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function Jn(t) {
    const n = Gn(t);
    if (!n) {
        throw Re(24);
    }
    return Yn(n);
}

function Yn(t) {
    const n = t;
    return n.qContainer ||= new Nc(n);
}

function Gn(t) {
    return t.closest("[q\\:container]:not([q\\:container=html]):not([q\\:container=text])");
}

const Mc = t => t instanceof Nc;

class Nc extends Qu {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    ht=new WeakMap;
    he;
    ue;
    Et=null;
    vNodeLocate=t => Go(this.rootVNode, t);
    de;
    pe;
    $e=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(Ke);
        if (!this.qContainer) {
            throw Re(25);
        }
        this.document = t.ownerDocument;
        this.element = t;
        this.ce = t.getAttribute(Be);
        this.ue = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = No(this.element);
        this.de = [];
        this.pe = [];
        const n = this.element.ownerDocument;
        n.qVNodeData || function e(t) {
            const n = "q:container";
            const e = "/" + n;
            const s = "q:ignore";
            const o = "/" + s;
            const r = "q:container-island";
            const i = "/" + r;
            const c = t;
            const l = c.qVNodeData || (c.qVNodeData = new WeakMap);
            const u = t.body;
            const f = u.getAttribute;
            const a = u.hasAttribute;
            const h = ((t, n) => {
                let e;
                for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
                    t = Object.getPrototypeOf(t);
                }
                return e || function() {
                    return this[n];
                };
            })(u, "nodeType");
            const d = t => {
                const n = t.querySelectorAll('script[type="qwik/vnode"]');
                for (let t = 0; t < n.length; t++) {
                    const e = n[t];
                    const s = e.closest("[q\\:container]");
                    s.qVnodeData = e.textContent;
                    s.qVNodeRefs = new Map;
                }
                const e = t.querySelectorAll("[q\\:shadowroot]");
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    const s = n.shadowRoot;
                    s && d(s);
                }
            };
            d(t);
            const p = t => {
                const c = h.call(t);
                if (c === 1) {
                    const e = f.call(t, n);
                    if (e === null) {
                        if (a.call(t, "q:shadowroot")) {
                            return 6;
                        }
                        const n = a.call(t, ":");
                        return n ? 2 : 0;
                    }
                    return 3;
                }
                if (c === 8) {
                    const c = t.nodeValue || "";
                    if (c.startsWith(r)) {
                        return 65;
                    }
                    if (c.startsWith(s)) {
                        return 16;
                    }
                    if (c.startsWith(n)) {
                        return 9;
                    }
                    if (c.startsWith(i)) {
                        return 64;
                    }
                    if (c.startsWith(o)) {
                        return 32;
                    }
                    if (c.startsWith(e)) {
                        return 8;
                    }
                }
                return 0;
            };
            const $ = t => {
                for (;t && (t = t.nextSibling) && p(t) === 0; ) {}
                return t;
            };
            const m = (n, e, s, o, r, i) => {
                const c = r.length;
                let u = 0;
                let f = -1;
                let a = 0;
                let h = 0;
                let d = 0;
                let y = -1;
                let w = null;
                const b = () => {
                    let t = 0;
                    for (;Pc(d = r.charCodeAt(a)); ) {
                        t += 1 << d - 33;
                        a++;
                        if (a >= c) {
                            break;
                        }
                    }
                    return t;
                };
                do {
                    if (s === o) {
                        return;
                    }
                    w = null;
                    const v = s == e ? 2 : p(s);
                    if (v === 3) {
                        const t = s;
                        let e = s;
                        for (;e && !(w = $(e)); ) {
                            e = e.parentNode;
                        }
                        m(n, t, s, w, t.qVnodeData || "", t.qVNodeRefs);
                    } else if (v === 16) {
                        let t = s;
                        do {
                            t = n.nextNode();
                            if (!t) {
                                throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                            }
                        } while (p(t) !== 65);
                        w = null;
                    } else if (v === 64) {
                        w = s;
                        let t;
                        do {
                            w = n.nextNode();
                            if (!w) {
                                throw Error("Ignore block not closed!");
                            }
                            t = p(w);
                        } while (t !== 32 && t !== 65);
                        w = null;
                    } else if (v === 9) {
                        w = s;
                        do {
                            w = $(w);
                            if (!w) {
                                throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                            }
                        } while (p(w) !== 8);
                        m(n, s, s, w, "", null);
                    } else if (v === 6) {
                        w = $(s);
                        const n = s;
                        const e = n?.shadowRoot;
                        e && m(t.createTreeWalker(e, 129), null, e, null, "", null);
                    }
                    if ((v & 2) === 2) {
                        if (f < u) {
                            f === -1 && (f = 0);
                            a = h;
                            if (a < c) {
                                f += b();
                                const t = d === 126;
                                if (t) {
                                    y = f;
                                    a++;
                                    d = a < c ? r.charCodeAt(h) : 33;
                                }
                                h = Ac(r, a, c);
                            } else {
                                f = Number.MAX_SAFE_INTEGER;
                            }
                        }
                        if (u === f) {
                            y === u && i.set(u, s);
                            const t = r.substring(a, h);
                            l.set(s, t);
                        }
                        u++;
                    }
                } while (s = w || n.nextNode());
            };
            const y = t.createTreeWalker(t, 129);
            m(y, null, y.firstChild(), null, "", null);
        }(n);
        this.he = Qe(n, this.ue) || Qi;
        this.me();
        t.setAttribute(Ke, "resumed");
        t.qContainer = this;
        t.qDestroy = () => this.En();
        const s = t.querySelectorAll('script[type="qwik/state"]');
        if (s.length !== 0) {
            const t = s[s.length - 1];
            this.de = JSON.parse(t.textContent);
            Pn(this.de, this);
            this.pe = pc(this, this.de);
        }
        this.ye();
        !he && t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    En() {
        this.vNodeLocate = () => null;
        this.de.length = 0;
        this.pe.length = 0;
        this._ = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        t.removeAttribute(Ke);
        t.ownerDocument.qVNodeData = void 0;
    }
    ye() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(We);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Rn(t, n) {
        this.pe[t] = n;
    }
    parseQRL(t) {
        const n = qn(t, this);
        return n;
    }
    handleError(t, n) {
        if (fe && n) {
            if (typeof document !== "undefined") {
                jt(n, t);
                on(this, n, 256);
            }
            t && t instanceof Error && ("hostElement" in t || (t.hostElement = n + ""));
            if (!(t => {
                if (t && t instanceof Error && "plugin" in t) {
                    return !1;
                }
                return !0;
            })(t)) {
                throw t;
            }
        }
        const e = n && this.resolveContext(n, Rc);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, ze);
        s == null && this.setHostProp(t, ze, s = []);
        ge(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, ze);
            if (e != null && Se(e, n.id, 0)) {
                return _e(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (Vo(n)) {
                if (Uo(n, Ce, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        zo(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case ur:
          case lr:
          case Ce:
          case ze:
          case Xe:
          case mr:
            s = this._;
            break;

          case cr:
          case pr:
            s = parseInt;
            break;
        }
        return Uo(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (T(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    _=t => Hn(t, this.pe);
    getSyncFn(t) {
        const n = this.he[t];
        return n;
    }
    we(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, Ue);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, Ue, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.$e == null) {
            this.$e = new Set;
            const t = this.document.querySelectorAll(Ve);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.$e.add(e.getAttribute(De));
            }
        }
        if (!this.$e.has(n)) {
            this.$e.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(De, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    me() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === wr) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.Lt = {
            containerAttributes: t
        };
    }
}

let Ic;

let ch;

if (oe) {
    const t = (() => {
        const t = globalThis.process;
        return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
    })();
    t && (ch = new t);
}

function Kn(t) {
    if (ch) {
        const t = ch.getStore();
        if (t) {
            return t;
        }
    }
    if (Ic === void 0) {
        const n = jc();
        if (n && n.Ct) {
            return n.Ct;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return Ic;
}

function Zn(t, n) {
    if (ch) {
        return ch.run(t, n);
    }
    const e = Ic;
    try {
        Ic = t;
        return n();
    } finally {
        Ic = e;
    }
}

let Cc;

const jc = () => Cc;

const Oc = () => {
    const t = jc();
    if (!t) {
        throw Re(9);
    }
    return t;
};

const Fc = () => {
    const t = jc();
    if (!t || t.jt !== ir) {
        throw Re(10);
    }
    return t;
};

function te(t, n, ...e) {
    return ne.call(this, t, n, e);
}

function ne(t, n, e) {
    const s = Cc;
    try {
        Cc = t;
        return n.apply(this, e);
    } finally {
        Cc = s;
    }
}

const Lc = (t, n) => {
    const e = Jn(n);
    const s = Go(e.rootVNode, n);
    const o = e.Ct;
    o && function r(t) {
        if (ch) {
            ch.enterWith(t);
            return;
        }
        Ic = t;
    }(o);
    const i = re(o, s, t);
    i.$ = e;
    return i;
};

function ee(t, n, e) {
    const s = {
        m: n,
        jt: ir,
        Ot: void 0,
        Ct: t,
        $: e,
        Ft: void 0
    };
    pe(s);
    return s;
}

function re(t, n, e) {
    const s = t || (e && Ee(e) && "locale" in e ? e.locale : void 0);
    const o = {
        m: n,
        jt: e,
        Ot: void 0,
        Ct: s,
        $: void 0
    };
    pe(o);
    return o;
}

const Dc = (t, ...n) => {
    if (typeof t === "function") {
        if (!Cc) {
            return t(...n);
        }
        {
            const e = Cc.Ot;
            try {
                Cc.Ot = void 0;
                return t(...n);
            } finally {
                Cc.Ot = e;
            }
        }
    }
    if (Gl(t)) {
        return t.untrackedValue;
    }
    return fu(t);
};

const Vc = /*#__PURE__*/ ee(void 0, void 0, void 0);

const Wc = (t, n, e, s, o) => {
    const r = Vc.Ot;
    const i = Vc.$;
    try {
        Vc.Ot = p(n, e, o);
        Vc.$ = s;
        return ne(Vc, t);
    } finally {
        Vc.Ot = r;
        Vc.$ = i;
    }
};

const Uc = (t, n, e, s, o) => {
    t instanceof ys && t.m !== n && n && (t.m = n);
    return Wc(() => t.value, n, e, s, o);
};

const zc = () => jc()?.m;

const Xc = () => {
    const t = jc();
    if (t) {
        return t.jt;
    }
};

const Qc = () => {
    const t = jc();
    if (t) {
        return t.$;
    }
};

const Bc = t => t;

const Hc = t => t.l || Promise.resolve();

let Jc = (t, n, e, s, o) => new Yc(t, n, e, s, o);

class Yc {
    vt;
    bt;
    be;
    ve;
    $;
    constructor(t, n, e, s, o) {
        this.vt = t;
        this.bt = n;
        this.be = e;
        this.ve = s;
        s && this.ge(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        fe && (t => {
            t.dev = null;
            typeof document !== "undefined" && (t.qrls = new Set);
        })(this);
        le && t && se(t, .8);
    }
    get st() {
        return sh(this.bt);
    }
    ge(t) {
        this.ve = t;
        _r(t) && t.then(t => this.ve = t, t => {
            console.error(`qrl ${this.bt} failed to load`, t);
            this.ve = null;
        });
    }
    _e() {
        if (this.ve != null) {
            return this.ve;
        }
        if (this.vt === "") {
            const t = this.$.ue;
            const n = this.$.element?.ownerDocument || document;
            const e = Qe(n, t);
            return this.ve = e[+this.bt];
        }
        le && this.vt && se(this.vt, 1);
        const t = this.bt;
        const n = this.be ? this.be().then(n => n[t]) : Vr().importSymbol(this.$?.element, this.vt, t);
        this.ge(n);
        return this.ve;
    }
}

le && import.meta.hot && (t => {
    if (!le || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        Jc = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t.vt;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t.vt;
            if (i) {
                t.vt = e(i, o);
                r = !0;
            }
            const c = t.be?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.be = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.bt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.bt}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.ve = void 0;
                document.__hmrDone = document.__hmrT;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    });
})(Yc);

const Gc = Symbol();

const Kc = t => t?.[Gc] ?? t;

class Zc {
    Se;
    resolved=void 0;
    Rt;
    $;
    constructor(t, n, e) {
        this.Se = t;
        fe && ((t, n, e) => {
            if (n && typeof n === "object") {
                for (let t = 0; t < n.length; t++) {
                    const e = n[t];
                    mc(e, "Captured variable in the closure can not be serialized");
                }
            }
            t.qrls && t.qrls.add(new WeakRef(e));
        })(t, n, this);
        if (n) {
            this.Rt = n;
            typeof n === "string" && (this.$ = e);
        }
        t.ve == null || typeof this.Rt === "string" || _r(t.ve) || (this.resolved = uf(this, t.ve));
    }
}

const tf = function(t, ...n) {
    const e = Kc(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = jc();
    return nf.call(e, s?.$).then(() => ne.call(t, s, e.resolved, n));
};

const nf = async function(t) {
    const n = Kc(this);
    return kr(cf(n, t), () => n.resolved);
};

const ef = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[Gc].resolved;
        },
        set(t) {
            this[Gc].resolved = t;
        }
    },
    Rt: {
        get() {
            return this[Gc].Rt;
        },
        set(t) {
            this[Gc].Rt = t;
        }
    },
    $: {
        get() {
            return this[Gc].$;
        },
        set(t) {
            this[Gc].$ = t;
        }
    },
    Se: {
        get() {
            return this[Gc].Se;
        }
    },
    vt: {
        get() {
            return this[Gc].Se.vt;
        }
    },
    bt: {
        get() {
            return this[Gc].Se.bt;
        }
    },
    st: {
        get() {
            return this[Gc].Se.st;
        }
    },
    dev: {
        get() {
            return this[Gc].Se.dev;
        }
    },
    ...fe ? {
        se: {
            value(t) {
                this[Gc].Se.dev = t;
            }
        }
    } : void 0,
    ke: {
        value: tf
    },
    w: {
        value: function(t) {
            const n = Kc(this);
            const e = new Zc(n.Se, t, n.Rt ? n.$ : void 0);
            return af(e);
        }
    },
    s: {
        value: function(t) {
            const n = Kc(this);
            n.Se.ge(t);
            n.resolved = uf(n, t);
        }
    },
    resolve: {
        value: nf
    },
    getSymbol: {
        value: function() {
            return Kc(this).Se.bt;
        }
    },
    getHash: {
        value: function() {
            return Kc(this).Se.st;
        }
    },
    getCaptured: {
        value: function() {
            const t = Kc(this);
            lf(t);
            return t.Rt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = Kc(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return nf.call(e).then(t => {
                        if (fe && !qe(t)) {
                            throw Re(5);
                        }
                        return s(...o);
                    });
                }
                if (n && n() === !1) {
                    return;
                }
                return ne(t, e.resolved, o);
            };
            return s;
        }
    }
});

let rf = null;

const sf = t => {
    rf = t;
};

const of = (t, n) => {
    const e = [];
    const s = n.split(" ");
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        e.push(t._(o));
    }
    return e;
};

const lf = t => {
    rf = t.Rt;
    const n = t.$;
    if (typeof rf === "string") {
        if (!n) {
            throw Re(13);
        }
        const e = oc;
        rf = t.Rt = of(n, rf);
        if (oc !== e) {
            return oc;
        }
    }
};

const uf = (t, n) => {
    if (typeof n !== "function" || !t.Rt) {
        return n;
    }
    return function e(...s) {
        lf(t);
        return n.apply(this, s);
    };
};

const cf = (t, n) => {
    const e = t.Se;
    const s = typeof t.Rt === "string";
    s && !t.$ && (t.$ = n || jc()?.$);
    if (t.resolved) {
        return;
    }
    const o = $f();
    const r = jc();
    const i = e._e();
    const c = kr(i, n => {
        t.resolved = uf(t, n);
    });
    if (c) {
        const t = e.bt;
        df(t, r?.m instanceof gi ? r?.m.node : void 0, o);
    }
    const l = s && t.$ && lf(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const ff = (t, n, e, s, o, r) => {
    const i = Jc(t, n, s, e, r);
    const c = new Zc(i, o, r);
    return af(c);
};

const af = t => {
    const n = async function(...t) {
        return tf.call(n, this, ...t);
    };
    n[Gc] = t;
    Object.setPrototypeOf(n, ef);
    return n;
};

const hf = /*#__PURE__*/ new Set;

const df = (t, n, e) => {
    if (!hf.has(t)) {
        hf.add(t);
        pf("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const pf = (t, n) => {
    he || Wr() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const $f = () => {
    if (he || Wr()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let mf = 0;

const yf = t => {
    if (!de && fe) {
        throw Error("Optimizer should replace all usages of $() with some special syntax. If you need to create a QRL manually, use inlinedQrl() instead.");
    }
    return ff(null, "s" + mf++, t, null, null);
};

const wf = yf;

const bf = t => t;

const vf = t => {
    if (!de && fe) {
        throw Error("Optimizer should replace all usages of sync$() with some special syntax. If you need to create a QRL manually, use inlinedSyncQrl() instead.");
    }
    fe && (t = Function("return " + t)());
    return ff("", Pe, t, null, null);
};

const gf = (t, n) => {
    n === void 0 && (n = "" + t);
    t.serialized = n;
    return ff("", Pe, t, null, null);
};

const _f = t => {
    function n(n, e, s = 0) {
        const o = he ? "sX" : t.st.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[Sf] = [ t ];
        return Ns(i, n, null, n.children, s, r);
    }
    n[Sf] = [ t ];
    return n;
};

const Sf = Symbol();

const kf = t => typeof t == "function" && t[Sf] !== void 0;

const Ef = t => _f(wf(t));

const xf = es(bf);

const Tf = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const qf = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !hi(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    if (fe && t.hasAttribute(Ke)) {
        throw Re(4, [ t ]);
    }
    t.setAttribute(Ke, "resumed");
    const s = Jn(t);
    s.Lt = e.serverData || {};
    const o = s.rootVNode;
    zo(o, Ti, n);
    on(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            Et(s, [], s.rootVNode);
        }
    };
};

const Rf = (t, n) => {
    const {val: e, set: s, iCtx: o} = fo();
    if (e != null) {
        return e;
    }
    const r = qe(t) ? te(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = hu(r, i, t);
        s(c);
        return c;
    }
};

const Pf = () => {
    const {val: t, set: n, iCtx: e} = fo();
    if (t != null) {
        return t;
    }
    const s = e.$.ce || "";
    const o = s ? Nr(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e.m, Ce);
    const i = r?.getHash().substring(0, 3) || "";
    const c = (t => (t => t.toString(36))(t.le++))(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function ie(t, n) {
    const e = jc();
    return e?.$?.Lt[t] ?? n;
}

const Af = /*#__PURE__*/ new Map;

const Mf = (t, n) => {
    if (fe) {
        return Nf(t, n);
    }
    let e = Af.get(n);
    e || Af.set(n, e = Nf(t, n));
    return e;
};

const Nf = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = Ff;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === aa) {
            r++;
            e = ua;
        }
        const s = ba[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, m, y] = p;
            if (($ === l || $ === Bf || $ === Hf && If(l) || $ === Yf && Of(l)) && (m === e || m === Bf || m === Hf && If(e) || m === Jf && !If(e) && e !== ia || m === Yf && Of(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (y === Xf || y == Qf) {
                    if (y === Qf) {
                        if (c !== Lf || h()) {
                            if (!Cf(e)) {
                                const t = m == Jf ? 1 : m == ea ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            Cf(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (m === Jf) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || Ff;
                        if (c === Df) {
                            u(r - 1);
                            i++;
                        }
                    } while (jf(c));
                } else {
                    o.push(c);
                    if (c === Df && y === Ff) {
                        u(r - 8);
                        i = r;
                    } else {
                        y === Vf && f(n);
                    }
                    c = y;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === Df || h()) {
            return;
        }
        u(t);
        s.push(".", Oe, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === ra) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === ra) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | da) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(Df) !== -1 || o.indexOf(Wf) !== -1;
    }
};

const If = t => t >= sa && t <= oa || t >= ua && t <= ca || t >= pa && t <= $a || t >= 128 || t === ha || t === ra;

const Cf = t => t === la || t === ia || t === fa || t === na || If(t);

const jf = t => t === Uf || t === Wf || t === zf || t === Df;

const Of = t => t === ta || t === Gf || t === Kf || t === Zf;

const Ff = 0;

const Lf = 2;

const Df = 5;

const Vf = 6;

const Wf = 10;

const Uf = 11;

const zf = 12;

const Xf = 17;

const Qf = 18;

const Bf = 0;

const Hf = 1;

const Jf = 2;

const Yf = 3;

const Gf = 9;

const Kf = 10;

const Zf = 13;

const ta = 32;

const na = 35;

const ea = 41;

const ra = 45;

const ia = 46;

const sa = 48;

const oa = 57;

const la = 58;

const ua = 65;

const ca = 90;

const fa = 91;

const aa = 92;

const ha = 95;

const da = 32;

const pa = 97;

const $a = 122;

const ma = 123;

const ya = 125;

const wa = /*@__PURE__*/ (() => [ [ Bf, 39, 14 ], [ Bf, 34, 15 ], [ Bf, 47, 16, "*" ] ])();

const ba = /*@__PURE__*/ (() => [ [ [ Bf, 42, Lf ], [ Bf, fa, 7 ], [ Bf, la, Vf, ":", "before", "after", "first-letter", "first-line" ], [ Bf, la, Df, "global" ], [ Bf, la, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ Bf, la, 4 ], [ Bf, Hf, 1 ], [ Bf, ia, 1 ], [ Bf, na, 1 ], [ Bf, 64, Wf, "keyframe" ], [ Bf, 64, Uf, "media", "supports", "container" ], [ Bf, 64, zf ], [ Bf, ma, 13 ], [ 47, 42, 16 ], [ Bf, 59, Xf ], [ Bf, ya, Xf ], [ Bf, ea, Xf ], ...wa ], [ [ Bf, Jf, Qf ] ], [ [ Bf, Jf, Qf ] ], [ [ Bf, 40, Ff ], [ Bf, Jf, Qf ] ], [ [ Bf, 40, 8 ], [ Bf, Jf, Qf ] ], [ [ Bf, 40, Ff ], [ Bf, Jf, Xf ] ], [ [ Bf, Jf, Xf ] ], [ [ Bf, 93, Qf ], [ Bf, 39, 14 ], [ Bf, 34, 15 ] ], [ [ Bf, ea, Xf ], ...wa ], [ [ Bf, ya, Xf ], ...wa ], [ [ Bf, ya, Xf ], [ Yf, Hf, 1 ], [ Bf, la, Df, "global" ], [ Bf, ma, 13 ], ...wa ], [ [ Bf, ma, Ff ], [ Bf, 59, Xf ], ...wa ], [ [ Bf, 59, Xf ], [ Bf, ma, 9 ], ...wa ], [ [ Bf, ya, Xf ], [ Bf, ma, 13 ], [ Bf, 40, 8 ], ...wa ], [ [ Bf, 39, Xf ] ], [ [ Bf, 34, Xf ] ], [ [ 42, 47, Xf ] ] ])();

const va = t => ({
    styleId: ka(t, t => t, !1)
});

const ga = /*#__PURE__*/ es(va);

const _a = t => ({
    scopeId: Oe + ka(t, Mf, !0)
});

const Sa = /*#__PURE__*/ es(_a);

const ka = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = fo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${Nr(t.st)}-${n}`)(t, i);
    const l = r.m;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.we(n(t, c), c, l, e));
    }
    r.$.we(n(t.resolved, c), c, l, e);
    return c;
};

const Ea = (t, n) => {
    t.resolve();
    return is(t, n);
};

const xa = (t, n) => po(Ea, t, n);

const Ta = es(xa);

const qa = t => {
    t.resolve();
    return os(t);
};

const Ra = t => po(qa, t);

const Pa = es(Ra);

const Aa = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = fo();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !Wr()) {
            e.h |= 32;
            Ma(e, i);
        }
        return;
    }
    let c;
    if (Wr()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        on(r.$, r.m, 1);
    }
    const l = new Hl(c, o, r.m, t, void 0, null);
    s(l);
    Ma(l, i);
};

const Ma = (t, n) => {
    n === "intersection-observer" ? Zu("qvisible", Na(t)) : n === "document-ready" ? tc("qinit", Na(t)) : n === "document-idle" && tc("qidle", Na(t));
};

const Na = t => ff(null, "_task", vn, null, [ t ]);

const Ia = es(Yu);

const Ca = /*#__PURE__*/ es(Ql);

const ja = /*#__PURE__*/ es(Aa);

const Oa = (t, n) => {
    t.resolve();
    return ss(t, n);
};

const Fa = (t, n) => po(Oa, t, n);

const La = es(Fa);

const Da = () => {
    const t = Rf({
        error: void 0
    });
    Ec(Rc, t);
    return t;
};

const Va = async ({track: t}) => {
    const n = rf[0];
    t(() => n.items);
    const e = jc();
    const s = e.m;
    const o = e.$;
    on(o, s, 128);
    const r = import.meta.env.TEST ? Wr() : oe;
    r && await o.l;
};

const Wa = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Ql(/*#__PURE__*/ Lu(Va, "_eaT", [ t ]));
    return Xs;
};

const Ua = /*#__PURE__*/ _f(
/*#__PURE__*/ Lu(Wa, "_eaC"));

const za = /*#__PURE__*/ kc("qk-reveal");

const Xa = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: ls(0)
});

const Qa = () => {
    const t = rf[0];
    if (t === null) {
        return !0;
    }
    const n = t.reveal;
    const e = t.item;
    const s = n.items;
    if (n.version.value < 0) {
        return !1;
    }
    switch (n.order) {
      case "together":
        for (let t = 0; t < s.length; t++) {
            if (s[t].boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < s.length; t++) {
            const n = s[t];
            if (n === e) {
                return !0;
            }
            if (n.boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = s.length - 1; t >= 0; t--) {
            const n = s[t];
            if (n === e) {
                return !0;
            }
            if (n.boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const Ba = ({cleanup: t}) => {
    const n = rf[0];
    t(() => {
        if (import.meta.env.TEST ? Wr() : !le) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Ha = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = po(Xa, t);
    Ec(za, n);
    /*#__PURE__*/
    return Ms(zs, null, null, null, 0, "u7_0");
};

const Ja = /*#__PURE__*/ _f(
/*#__PURE__*/ Lu(Ha, "_reC"));

const Ya = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || e !== null && !e.value && s.reveal.collapsed ? "none" : "contents"
});

const Ga = (t, n, e) => ({
    display: e !== null && !e.value || n.value !== "content" && !t.showStale ? "none" : "contents"
});

const Ka = ({track: t, cleanup: n}) => {
    const e = rf[0], s = rf[1], o = rf[2], r = rf[3];
    const i = t(e.pending);
    const c = import.meta.env.TEST ? !Wr() : le;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.pending.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Za = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = ho("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return po($o);
    })();
    const s = (t => {
        const n = xc(za, null);
        const e = po(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Ql(/*#__PURE__*/ Lu(Ba, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = xa(
    /*#__PURE__*/ Lu(Qa, "_reR", [ s ]));
    Ql(
    /*#__PURE__*/ Lu(Ka, "_suT", [ e, t, n, s ]));
    /*#__PURE__*/
    return Ms(Vs, null, null, [ 
    /*#__PURE__*/ Ms("div", {
        style: Xu(Ya, [ t, n, o, s ], '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2===null||p2.value||!p3.reveal.collapsed)?"contents":"none"}')
    }, null, ps(t, "fallback"), 1, null), 
    /*#__PURE__*/ Ms("div", null, {
        style: Xu(Ga, [ t, n, o ], '{display:(p2===null||p2.value)&&(p1.value==="content"||p0.showStale)?"contents":"none"}')
    }, 
    /*#__PURE__*/ Ms(zs, {
        [mr]: e
    }, null, null, 3, "u6_0"), 1, null) ], 1, "u6_1");
};

const th = /*#__PURE__*/ _f(
/*#__PURE__*/ Lu(Za, "_suC"));

const nh = t => {
    import.meta;
    const n = import.meta.env.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    e.path = t?.path?.startsWith?.("/") ? t.path : n + e.path;
    let s = eh.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return Ms("script", null, o, null, 0, "prefetch-service-worker");
};

const eh = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const rh = () => null;

globalThis.__qwik && Re(30, [ globalThis.__qwik, ai ]);

globalThis.__qwik = ai;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { yf as $, Ua as Each, Vs as Fragment, _c as NoSerializeSymbol, rh as PrefetchGraph, nh as PrefetchServiceWorker, Ws as RenderOnce, Gu as Resource, Ja as Reveal, Bs as SSRComment, Qs as SSRRaw, Js as SSRStream, Hs as SSRStreamBlock, Sc as SerializerSymbol, Xs as SkipRender, zs as Slot, th as Suspense, Di as _CONST_PROPS, Nc as _DomContainer, di as _EFFECT_BACK_REF, Qi as _EMPTY_ARRAY, Bi as _EMPTY_OBJ, zi as _IMMUTABLE, Qu as _SharedContainer, ws as _SubscriptionData, Xi as _UNINITIALIZED, Vi as _VAR_PROPS, Ln as _addProjection, rf as _captures, y as _chk, ff as _createQRL, Bn as _deserialize, Mu as _dumpState, Wa as _eaC, Va as _eaT, rn as _executeSsrChores, Xu as _fnSignal, ts as _getConstProps, Qc as _getContextContainer, Xc as _getContextEvent, zc as _getContextHostElement, Jn as _getDomContainer, Gn as _getQContainerElement, Zi as _getVarProps, cu as _hasStoreEffects, ic as _hmr, Ss as _isJSXNode, au as _isStore, Mn as _isStringifiable, Jl as _isTask, Bc as _jsxBranch, Is as _jsxC, js as _jsxQ, Cs as _jsxS, Ms as _jsxSorted, Ns as _jsxSplit, ve as _mapApp_findIndx, _e as _mapArray_get, ge as _mapArray_set, Du as _noopQrl, Vu as _noopQrlDEV, Pn as _preprocessState, gf as _qrlSync, xn as _qrlToString, Ha as _reC, Qa as _reR, Ba as _reT, zu as _regSymbol, Wn as _removeProjection, w as _res, qc as _resolveContextWithoutSequentialScope, Zs as _restProps, Ju as _rsc, C as _run, Qn as _serialize, jn as _setEvent, Dn as _setProjectionTarget, Za as _suC, Ka as _suT, vn as _task, Vn as _updateProjectionProps, Fn as _useHmr, m as _val, mc as _verifySerializable, Bo as _vnode_ensureElementInflated, jl as _vnode_getAttrKeys, $l as _vnode_getElementName, wl as _vnode_getFirstChild, Uo as _vnode_getProp, tl as _vnode_getVNodeForChildNode, fl as _vnode_insertBefore, Oo as _vnode_isElementVNode, Lo as _vnode_isMaterialized, Do as _vnode_isTextVNode, Vo as _vnode_isVirtualVNode, Co as _vnode_newVirtual, dl as _vnode_remove, zo as _vnode_setProp, dn as _vnode_toString, Hc as _waitUntilRendered, In as _walkJSX, ps as _wrapProp, ms as _wrapSignal, Ef as component$, _f as componentQrl, cs as createAsync$, ss as createAsyncQrl, us as createComputed$, is as createComputedQrl, kc as createContextId, b as createElement, fs as createSerializer$, os as createSerializerQrl, ls as createSignal, xf as event$, bf as eventQrl, uu as forceStoreEffects, Tf as getClientManifest, Jn as getDomContainer, Kn as getLocale, Vr as getPlatform, b as h, es as implicit$FirstArg, Lu as inlinedQrl, Uu as inlinedQrlDEV, ue as isDev, Gl as isSignal, Fs as jsx, Ls as jsxDEV, Ds as jsxs, gc as noSerialize, Fu as qrl, Wu as qrlDEV, qf as render, Dr as setPlatform, vf as sync$, Dc as untrack, fu as unwrapStore, La as useAsync$, Fa as useAsyncQrl, Ta as useComputed$, xa as useComputedQrl, po as useConstant, xc as useContext, Ec as useContextProvider, Da as useErrorBoundary, Pf as useId, Hu as useLexicalScope, Zu as useOn, tc as useOnDocument, nc as useOnWindow, Ia as useResource$, Yu as useResourceQrl, Pa as useSerializer$, Ra as useSerializerQrl, ie as useServerData, ho as useSignal, Rf as useStore, ga as useStyles$, va as useStylesQrl, Sa as useStylesScoped$, _a as useStylesScopedQrl, Ca as useTask$, Ql as useTaskQrl, ja as useVisibleTask$, Aa as useVisibleTaskQrl, ai as version, Zn as withLocale };
